export default {
    app: {
        title: 'Mediasbox',
        description: 'Gérez vos vidéos et fichiers',
    },
    onisep: {
        title: 'ONISEP',
        label: {
            synchronised: 'Synchronisé',
            notSynchronised: 'Non synchronisé',
        },
        labelHint: {
            synchronised: 'Ce média répond aux règles d’envoi vers le catalogue ONISEP : chacune de ses modifications lui est envoyée.',
            notSynchronised: 'Ce média ne répond pas aux règles d’envoi vers le catalogue ONISEP : ses modifications ne lui sont pas envoyées.',
        },
        loading: 'Lecture de l’état ONISEP…',
        loadError: 'Impossible de lire l’état ONISEP de ce média.',
        refused: 'Non envoyé : {conditions}.',
        conditions: {
            not_sendable: 'ce type de média n’est jamais envoyé',
            not_a_video_collection: 'seules les collections de vidéos sont envoyées',
            retired: 'le média est dans la corbeille',
            internal: 'le média est interne',
            outside_pool: 'le média n’est pas dans le fonds commun',
            pool_pending: 'son partage dans le fonds commun attend une validation',
            pool_rejected: 'son partage dans le fonds commun a été refusé',
            pool_under_revision: 'une modification demandée dans le fonds commun attend la validation d’un modérateur',
            not_exploited: 'le champ « Exploitation sites internet » ne contient ni OnisepTV, ni Onisep.fr edito, ni Kiosque',
            no_slug: 'le média n’a pas de slug, qu’ONISEP exige',
        },
        stillHeld: 'ONISEP conserve la version reçue le {date} : rien n’est retiré de son catalogue.',
        lastSent: 'Dernier envoi réussi le {date}.',
        neverSent: 'Pas encore envoyé à ONISEP.',
        pending: {
            waiting: 'Un envoi est en attente.',
            sending: 'Envoi en cours…',
            retrying: 'Le dernier essai a échoué ; prochain essai le {date}.',
        },
        sendNow: 'Envoyer maintenant',
        sendNowHint: 'Renvoie ce média à ONISEP même si rien n’a changé, par exemple après un incident de leur côté.',
        sendQueued: 'Envoi vers ONISEP programmé.',
        sendJoined: 'Envoi vers ONISEP programmé : l’envoi qui attendait part maintenant.',
        sendInFlight: 'Un envoi vers ONISEP est en cours. S’il ne contient pas vos dernières modifications, relancez l’envoi une fois celui-ci terminé.',
        sendRefused: 'ONISEP n’accepte pas ce média pour le moment.',
        sendError: 'Impossible de programmer l’envoi vers ONISEP.',
        journal: {
            title: 'Journal des envois',
            show: 'Afficher le journal des envois',
            hide: 'Masquer le journal des envois',
            empty: 'Aucun envoi pour le moment.',
            loadError: 'Impossible de lire le journal des envois.',
            more: 'Afficher plus',
            manual: 'Manuel',
            noCall: 'Aucun appel',
            state: {
                waiting: 'En attente',
                sending: 'En cours',
                retrying: 'Échec, nouvel essai prévu',
                sent: 'Envoyé',
                skipped: 'Sans envoi',
                failed: 'Abandonné',
            },
            action: {
                created: 'Création',
                updated: 'Mise à jour',
                playlist: 'Playlist',
            },
            http: 'HTTP {code}',
            latency: '{ms} ms',
        },
    },
    workspaces: {
        title: 'Espaces',
        spaces: 'espaces',
        navigation: {
            media: 'Médias',
            shares: 'Partages',
            trash: 'Corbeille',
            recent: 'Récents',
            unfold: 'Afficher les listes de l\'espace',
            fold: 'Masquer les listes de l\'espace',
            unfoldFolders: 'Afficher les dossiers',
            foldFolders: 'Masquer les dossiers',
            unfoldFolder: 'Afficher les sous-dossiers',
            foldFolder: 'Masquer les sous-dossiers',
            folderCount: '{count} élément | {count} élément | {count} éléments',
            noFolders: 'Aucun dossier',
            foldersError: 'Impossible de charger les dossiers',
        },
        pickerLabel: '{workspace} : changer d’espace',
        toggleCompact: 'Mode compact',
        expand: 'Développer',
        create: 'Créer un nouvel espace',
        search: 'Rechercher des espaces...',
        emptyState: {
            title: 'Aucun espace',
            description: 'Créez votre premier espace pour organiser vos fichiers.',
            action: 'Créer un espace',
        },
        noWorkspace: {
            title: 'Vous n\'avez plus d\'espace',
            description: 'Les espaces contiennent vos vidéos, vos sous-titres et vos partages. Créez-en un pour reprendre votre travail.',
            action: 'Créer un espace',
            restrictedTitle: 'Vous n\'avez accès à aucun espace',
            restrictedDescription: 'Un administrateur de votre organisation doit vous donner accès à un espace, ou vous autoriser à en créer un.',
        },
        overview: 'Vue d\'ensemble',
        searchResults: 'Résultats de recherche',
        favorites: 'Favoris',
        recent: 'Récents',
        all: 'Tous les espaces',
        noResults: 'Aucun résultat pour "{query}"',
        empty: 'Aucun fichier',
        oneFile: '1 fichier',
        multipleFiles: '{count} fichiers',
        videoStorage: 'Stockage vidéo',
        fileStorage: 'Stockage fichiers',
        storage: 'Stockage',
        videos: 'Vidéos',
        files: 'Fichiers',
        createModal: {
            title: 'Créer un espace',
            nameLabel: 'Nom',
            nameHint: 'Choisissez un nom pour votre espace.',
            namePlaceholder: 'Mon espace',
            nameRequired: 'Le nom est requis',
            descriptionLabel: 'Description',
            descriptionHint: 'Ajoutez une description pour identifier cet espace.',
            descriptionPlaceholder: 'Description de l\'espace...',
            colorLabel: 'Couleur',
            colorHint: 'Choisissez une couleur pour votre espace.',
            colorPlaceholder: 'Sélectionner une couleur',
            privacyLabel: 'Confidentialité',
            privacyHint: 'Contrôlez qui peut accéder à cet espace.',
            public: 'Public',
            private: 'Privé',
            publicNote: 'Tous les membres de l\'organisation peuvent voir cet espace.',
            privateNote: 'Seuls les membres invités peuvent voir cet espace.',
            createButton: 'Créer',
            defaultName: 'Mon espace',
            moreOptions: 'Description, couleur et visibilité',
            success: 'Espace créé. Vous pouvez importer vos vidéos.',
            noOrganization: 'Aucune organisation sélectionnée',
            error: 'Échec de la création de l\'espace',
        },
        renameModal: {
            title: 'Modifier l\'espace',
            nameLabel: 'Nom',
            nameRequired: 'Le nom est requis',
            descriptionLabel: 'Description',
            colorLabel: 'Couleur',
            success: 'Espace mis à jour',
            error: 'Échec de la mise à jour de l\'espace',
        },
        deleteModal: {
            title: 'Supprimer l\'espace',
            titleNamed: 'Supprimer « {name} » ?',
            warning: 'Les fichiers de cet espace, leurs sous-titres et leurs partages seront définitivement supprimés. Cette action est irréversible.',
            lastOneWarning: 'C\'est votre dernier espace. Sans espace, vous ne pourrez plus importer de vidéos ni générer de sous-titres. Vous pourrez en créer un nouveau à tout moment.',
            confirm: 'Supprimer l\'espace',
            success: 'Espace supprimé',
            error: 'Échec de la suppression de l\'espace',
        },
        pin: {
            success: 'Espace épinglé',
        },
        unpin: {
            success: 'Espace désépinglé',
        },
        pools: 'Pools',
        pendingModeration: 'en attente | en attente',
        revisionsModeration: '{count} révision à valider | {count} révisions à valider',
        invite: 'Ajouter un membre',
        moreActions: 'Plus d\'actions',
        shared: 'Partagé',
        private: 'Privé',
        public: 'Public',
        file: 'fichier',
        menu: {
            open: 'Ouvrir',
            viewStats: 'Voir les statistiques',
            invite: 'Ajouter des membres',
            pin: 'Épingler aux favoris',
            unpin: 'Retirer des favoris',
            rename: 'Renommer',
            settings: 'Paramètres',
            delete: 'Supprimer',
            moderation: 'Modération',
        },
        drawerMenu: {
            title: 'Trier et filtrer',
            sortBy: 'Trier par',
            filters: 'Filtres',
            hideEmpty: 'Masquer les espaces vides',
            onlyPrivate: 'Priv\u00e9s uniquement',
            onlyFavorites: 'Favoris uniquement',
            hideRecent: 'Masquer les r\u00e9cents',
            reset: 'R\u00e9initialiser',
            noMatchingWorkspaces: 'Aucun espace correspondant',
            sort: {
                nameAsc: 'Alphab\u00e9tique (A\u2013Z)',
                nameDesc: 'Alphab\u00e9tique (Z\u2013A)',
                contentDesc: 'Plus de contenu',
                contentAsc: 'Moins de contenu',
                sizeDesc: 'Plus volumineux',
                updatedDesc: 'R\u00e9cemment modifi\u00e9s',
                createdDesc: 'R\u00e9cemment cr\u00e9\u00e9s',
            },
        },
        backToTop: 'Retour en haut',
        pinSuccess: 'Espace épinglé',
        unpinSuccess: 'Espace désépinglé',
        pinError: 'Échec de la mise à jour',
        settings: {
            title: 'Paramètres',
            globalTitle: 'Paramètres globaux',
            placeholder: 'Bientôt disponible...',
            general: 'Général',
            members: 'Membres',
            design: 'Design',
            player: 'Lecteurs de médias',
            tags: 'Tags',
            embed: 'Paramètres d\'intégration',
            advertising: 'Publicité',
            cta: 'Appels à l\'action',
            sharing: 'Paramètres des liens de partage',
            export: 'Export',
            shares: 'Historiques des partages',
            deletionHistory: 'Historique des suppressions',
            presets: 'Presets d\'intégration',
            presetsDescription: 'Gérer les presets d\'intégration par défaut pour cet espace',
            sections: {
                general: 'Général',
                appearance: 'Apparence',
                content: 'Contenu',
                display: 'Affichage',
                integration: 'Intégration',
                share: 'Partage',
                data: 'Données',
            },
            exportSettings: {
                title: 'Exporter les assets',
                subtitle: 'Téléchargez les données de vos assets, en CSV ou dans un classeur Excel.',
                workspace: 'Espace de travail',
                noWorkspace: 'Aucun espace de travail où vous pouvez exporter des assets.',
                format: 'Format d\'export',
                formatDescription: 'Choisissez le format de votre fichier d\'export.',
                formatCsv: 'CSV',
                formatXlsx: 'Excel (XLSX)',
                formatHint: {
                    csv: 'Des points-virgules entre les colonnes et une virgule décimale : le fichier s\'ouvre en colonnes dans un tableur réglé en français, et se lit par un script.',
                    xlsx: 'Une feuille, ses nombres et ses dates reconnus comme tels, prête à trier et à additionner. Jusqu\'à 1 048 575 assets : au-delà, choisissez le CSV.',
                },
                analyticsPeriod: {
                    label: 'Période des statistiques',
                    lifetime: 'Toute la durée de vie',
                    period: 'Une période',
                    from: 'Du',
                    until: 'Au',
                    lifetimeHint: 'Les colonnes de statistiques comptent toutes les sessions et toutes les notes enregistrées pour chaque asset.',
                    periodHint: 'Des jours entiers en temps universel (UTC), bornes comprises ; la période figure dans l\'intitulé des colonnes de statistiques. Une date laissée vide laisse la période ouverte de ce côté. Elle n\'est pas enregistrée dans un preset.',
                    inverted: 'La date de début est postérieure à la date de fin.',
                },
                filters: 'Filtres',
                dateRange: 'Période',
                startDate: 'Date de début',
                endDate: 'Date de fin',
                assetTypes: 'Types d\'assets',
                search: 'Recherche',
                searchPlaceholder: 'Rechercher par nom...',
                fields: 'Champs à exporter',
                fieldsDescription: 'Sélectionnez les champs à inclure dans l\'export.',
                selectAll: 'Tout sélectionner',
                deselectAll: 'Tout désélectionner',
                exportButton: 'Exporter',
                exporting: 'Export en cours...',
                syncSuccess: 'Export prêt ! Votre fichier est en cours de téléchargement.',
                queueButton: 'Préparer l\'export',
                queued: 'Votre export est en préparation. Vous recevrez un e-mail avec un lien de téléchargement dès qu\'il sera prêt — il figure déjà dans le journal ci-dessous.',
                queuedTo: 'Votre export est en préparation. Vous recevrez un e-mail à {email} avec un lien de téléchargement dès qu\'il sera prêt — il figure déjà dans le journal ci-dessous.',
                asyncNotice: 'À partir de {threshold} assets, un export est préparé en arrière-plan : vous recevrez un e-mail avec un lien de téléchargement, valable 7 jours.',
                error: 'Échec de l\'export des assets',
                noFields: 'Veuillez sélectionner au moins un champ à exporter.',
                featureDisabled: 'L\'export d\'assets n\'est pas disponible pour votre organisation.',
                countBanner: '{count} asset(s) seront exportés',
                countLoading: 'Comptage en cours...',
                collectionSubtypes: 'Types de collections',
                collectionVideos: 'Vidéos',
                collectionAudios: 'Audios',
                collectionImages: 'Images',
                collectionDocuments: 'Documents',
                relation: {
                    label: 'Relations',
                    all: 'Tous les assets',
                    target: 'Cibles d\'une relation',
                    source: 'Sources d\'une relation',
                    hint: 'Cibles : les assets vers lesquels pointe une relation. Sources : les assets d\'où part une relation.',
                },
                organization: {
                    scope: 'Espaces de travail et modération',
                    workspaces: 'Espaces de travail',
                    allWorkspaces: 'Tous les espaces de travail',
                    workspacesHint: 'Aucun sélectionné : tous les espaces de travail de l\'organisation. La liste les propose tous, y compris ceux où vous n\'avez pas de place, avec le nombre d\'assets placés dans chacun — en attente et refusés compris.',
                    workspaceAssets: 'Aucun asset | 1 asset | {count} assets',
                    poolAssets: 'Fonds commun · aucun asset | Fonds commun · 1 asset | Fonds commun · {count} assets',
                    moderation: 'Statut de modération',
                    moderationHint: 'Aucun sélectionné : tous les statuts, en attente et refusés compris.',
                    asyncNotice: 'L\'export de l\'organisation est toujours préparé en arrière-plan : vous recevrez un e-mail avec un lien de téléchargement, valable 7 jours.',
                },
                log: {
                    title: 'Journal des exports',
                    workspaceDescription: 'Chaque export de cet espace de travail, quel qu\'en soit l\'auteur ou l\'issue. Un fichier préparé en arrière-plan reste téléchargeable 7 jours, par la personne qui l\'a demandé.',
                    organizationDescription: 'Chaque export de chaque espace de travail et de toute l\'organisation, avec l\'adresse et le navigateur d\'où il a été demandé — conservé aussi longtemps que l\'organisation. Un fichier préparé en arrière-plan reste téléchargeable 7 jours, par la personne qui l\'a demandé.',
                    empty: 'Aucun export pour le moment.',
                    loadError: 'Le journal des exports n\'a pas pu être chargé.',
                    loadMore: 'Afficher plus',
                    columns: {
                        date: 'Date',
                        requester: 'Demandé par',
                        scope: 'Périmètre',
                        mode: 'Livraison',
                        format: 'Format',
                        status: 'Statut',
                        rows: 'Assets',
                        file: 'Fichier',
                        origin: 'Origine',
                    },
                    erasedAccount: 'Compte effacé',
                    organizationScope: 'Toute l\'organisation',
                    mode: {
                        sync: 'Téléchargement direct',
                        async: 'Par e-mail',
                    },
                    status: {
                        queued: 'En attente',
                        running: 'En cours',
                        finished: 'Terminé',
                        failed: 'Échec',
                    },
                    failureDetail: 'Détail technique : {error}',
                    download: 'Télécharger',
                    expiresOn: 'Jusqu\'au {date}',
                    expired: 'Lien expiré',
                    sentToRequester: 'Envoyé au demandeur',
                    preparing: 'En préparation',
                    analyticsPeriod: 'Statistiques {period}',
                    periodBetween: 'du {start} au {end}',
                    periodSince: 'depuis le {start}',
                    periodUntil: 'jusqu\'au {end}',
                },
                presets: {
                    label: 'Preset',
                    placeholder: 'Sélectionner un preset...',

                    save: 'Enregistrer le preset',
                    delete: 'Supprimer',
                    saveTitle: 'Enregistrer un preset d\'export',
                    nameLabel: 'Nom du preset',
                    namePlaceholder: 'Entrez un nom pour ce preset...',
                    saveSuccess: 'Preset enregistré avec succès.',
                    saveError: 'Échec de l\'enregistrement du preset.',
                    deleteTitle: 'Supprimer le preset',
                    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer le preset « {name} » ?',
                    deleteSuccess: 'Preset supprimé.',
                    deleteError: 'Échec de la suppression du preset.',
                    duplicateName: 'Un preset avec ce nom existe déjà.',
                    hint: 'Réglages modifiés \u2014',
                    hintAction: 'Enregistrer comme preset',
                    renameTitle: 'Renommer le preset',
                    renameSuccess: 'Preset renommé avec succès.',
                    renameError: 'Échec du renommage du preset.',
                    updateHint: 'Réglages du preset modifiés \u2014',
                    updateAction: 'Mettre à jour le preset',
                    updateSuccess: 'Preset mis à jour avec succès.',
                    updateError: 'Échec de la mise à jour du preset.',
                },
            },
            embedSettings: {
                title: 'Paramètres d\'intégration',
                subtitle: 'Contrôlez quels domaines sont autorisés à intégrer vos vidéos et fichiers via iframe.',
                restrictDomains: 'Restreindre les domaines d\'intégration',
                restrictDomainsDescription: 'Lorsque activé, seuls les domaines listés ci-dessous pourront intégrer votre contenu. Lorsque désactivé, votre contenu peut être intégré sur n\'importe quel site.',
                allowedDomains: 'Domaines autorisés',
                allowedDomainsDescription: 'Ajoutez les domaines autorisés à intégrer votre contenu.',
                addDomain: 'Ajouter un domaine',
                domainPlaceholder: 'exemple.com',
                wildcardHint: 'Les jokers sont pris en charge (ex. *.exemple.com pour autoriser tous les sous-domaines).',
                removeDomain: 'Supprimer le domaine',
                noDomains: 'Aucun domaine configuré',
                noDomainsDescription: 'Ajoutez au moins un domaine pour autoriser l\'intégration lorsque les restrictions sont activées.',
                saveSuccess: 'Paramètres d\'intégration mis à jour',
                saveError: 'Échec de la mise à jour des paramètres d\'intégration',
                invalidDomain: 'Veuillez saisir un nom de domaine valide',
                duplicateDomain: 'Ce domaine est déjà dans la liste',
                domainRequired: 'Ajoutez au moins un domaine autorisé, ou désactivez la restriction — sinon l\'intégration serait bloquée partout.',
                domainCount: '{count} domaine(s)',
                lockPresetCustomization: 'Verrouiller la personnalisation du lecteur',
                lockPresetCustomizationDescription: 'Lorsque activé, les utilisateurs ne peuvent qu\'appliquer des préréglages existants. Ils ne peuvent pas modifier les réglages du lecteur ni créer de nouveaux préréglages.',
            },
            sharingSettings: {
                title: 'Liens de partage',
                orgSubtitle: 'Configurez l\'expiration par défaut appliquée lors de la création de nouveaux liens de partage dans votre organisation.',
                workspaceSubtitle: 'Réglez l\'expiration par défaut et le logo des liens de partage créés dans cet espace de travail.',
                defaultExpirationEnabled: 'Activer l\'expiration par défaut',
                defaultExpirationEnabledDescription: 'Lorsque activé, les nouveaux liens de partage ont une date d\'expiration pré-remplie. Les utilisateurs peuvent toujours la désactiver manuellement pour chaque lien.',
                defaultExpirationDays: 'Durée par défaut',
                defaultExpirationDaysDescription: 'Nombre de jours avant qu\'un nouveau lien de partage n\'expire par défaut.',
                daysSuffix: 'jours',
                daysOutOfRange: 'Veuillez saisir un nombre de jours entre 1 et 3650.',
                customLogoTitle: 'Logo personnalisé du partage',
                customLogoDescription: 'Téléversez un logo affiché dans l\'en-tête des pages publiques de partage. Si vide, le logo de la plateforme est utilisé.',
                customLogoHelper: 'PNG, JPEG ou WebP. Taille recommandée : 200×200px.',
                customLogoInheritedFromOrg: 'Cet espace de travail utilise le logo personnalisé de l\'organisation. Téléversez un nouveau logo pour le remplacer ici.',
                customLogoError: 'Impossible d\'enregistrer le logo personnalisé. Veuillez réessayer.',
            },
            inheritance: {
                inherit: 'Utiliser les réglages de « Tous les espaces »',
                inheritHint: 'Cet espace suit les réglages définis pour tous les espaces, et leurs modifications s\'y appliquent.',
                openOrg: 'Voir les réglages de « Tous les espaces »',
                custom: 'Personnaliser pour cet espace',
                customHint: 'Cet espace a ses propres réglages, qui ne suivent plus ceux de « Tous les espaces ».',
            },
            advertisingSettings: {
                title: 'Publicité',
                subtitle: 'Configurez les paramètres de publicité VAST pour le contenu intégré de cet espace.',
                orgSubtitle: 'Configurez les paramètres de publicité VAST par défaut pour tous les espaces de votre organisation.',
                enabled: 'Activer la publicité VAST',
                enabledDescription: 'Lorsque activé, les publicités VAST seront affichées sur le contenu intégré. Vous devez fournir une URL de tag VAST valide ci-dessous.',
                vastUrl: 'URL du tag VAST',
                vastUrlDescription: 'Saisissez l\'URL de votre tag VAST. Cette URL sera utilisée pour récupérer et afficher les publicités vidéo.',
                vastUrlPlaceholder: 'https://exemple.com/vast-tag.xml',
                skipAfter: 'Passage forcé de la publicité',
                skipAfterDescription: 'Au bout de ce délai, le lecteur propose de passer la publicité, même si le tag VAST ne le prévoit pas. Le délai le plus court des deux l\'emporte : une publicité que l\'annonceur rend passable plus tôt le reste. Laissez vide pour vous en remettre au tag. Attention : forcer le passage avant le délai de l\'annonceur diffuse la publicité de façon incomplète et peut sortir des conditions de votre régie.',
                skipAfterPlaceholder: 'Aucun passage forcé',
                skipAfterUnit: 'secondes',
                excludedDomains: 'Domaines exclus',
                excludedDomainsDescription: 'Ajoutez les domaines sur lesquels les publicités ne doivent pas être affichées. Les intégrations sur ces domaines ne montreront pas de publicités.',
                addDomain: 'Ajouter un domaine',
                domainPlaceholder: 'exemple.com',
                wildcardHint: 'Les jokers sont pris en charge (ex. *.exemple.com pour exclure tous les sous-domaines).',
                noDomains: 'Aucun domaine exclu',
                noDomainsDescription: 'Tous les domaines d\'intégration afficheront des publicités. Ajoutez des domaines ici pour les exclure de la diffusion publicitaire.',
                saveSuccess: 'Paramètres de publicité mis à jour',
                saveError: 'Échec de la mise à jour des paramètres de publicité',
                invalidDomain: 'Veuillez saisir un nom de domaine valide',
                duplicateDomain: 'Ce domaine est déjà dans la liste',
                domainCount: '{count} domaine(s)',
            },
            tagSettings: {
                title: 'Tags',
                subtitle: 'Gérez les tags de l\'espace et contrôlez comment les tags peuvent être appliqués aux fichiers.',
                restrictToExisting: 'Restreindre aux tags existants',
                restrictToExistingDescription: 'Lorsque activé, les utilisateurs ne peuvent appliquer que des tags préexistants aux fichiers. Lorsque désactivé, les utilisateurs peuvent créer de nouveaux tags librement.',
                tagList: 'Tags',
                tagCount: '{count} tag(s)',
                addTag: 'Ajouter un tag',
                tagPlaceholder: 'Nom du tag',
                noTags: 'Aucun tag',
                noTagsDescription: 'Créez des tags pour organiser et catégoriser vos fichiers.',
                orgScope: 'Organisation',
                workspaceScope: 'Espace',
                filterByTag: 'Voir les fichiers avec ce tag',
                deleteTag: 'Supprimer le tag',
                deleteTagConfirmTitle: 'Supprimer le tag',
                deleteTagConfirm: 'Ce tag est utilisé par {count} fichier(s). Le supprimer le retirera de tous les fichiers. Cette action est irréversible.',
                deleteTagConfirmUnused: 'Êtes-vous sûr de vouloir supprimer ce tag ? Cette action est irréversible.',
                inherited: 'Hérité de l\'organisation',
                overridden: 'Personnalisé',
                resetTitle: 'Réinitialiser les paramètres',
                resetDescription: 'Supprimez les personnalisations et revenez aux paramètres par défaut de l\'organisation.',
                resetToDefaults: 'Réinitialiser',
                resetConfirmTitle: 'Réinitialiser les paramètres de tags',
                resetConfirm: 'Cela supprimera tous les paramètres de tags au niveau de l\'espace et reviendra aux valeurs par défaut de l\'organisation. Cette action est irréversible.',
                createSuccess: 'Tag créé',
                createError: 'Échec de la création du tag',
                deleteSuccess: 'Tag supprimé',
                deleteError: 'Échec de la suppression du tag',
                saveSuccess: 'Paramètres de tags mis à jour',
                saveError: 'Échec de la mise à jour des paramètres de tags',
                resetSuccess: 'Paramètres de tags réinitialisés',
                resetError: 'Échec de la réinitialisation des paramètres de tags',
                duplicateTag: 'Ce tag existe déjà',
                assets: 'fichier(s)',
            },
            generalSettings: {
                title: 'Général',
                subtitle: 'Gérez le nom, la description et la visibilité de l\'espace.',
                basicInfo: 'Informations de base',
                basicInfoDescription: 'Modifiez le nom et la description de l\'espace.',
                nameLabel: 'Nom',
                namePlaceholder: 'Mon espace',
                nameRequired: 'Le nom est requis',
                descriptionLabel: 'Description',
                descriptionPlaceholder: 'Description de l\'espace...',
                appearance: 'Apparence',
                appearanceDescription: 'Personnalisez l\'identité visuelle de votre espace.',
                colorLabel: 'Couleur',
                access: 'Accès',
                accessDescription: 'Contrôlez qui peut accéder à cet espace.',
                privateLabel: 'Espace privé',
                publicNote: 'Tous les membres de l\'organisation peuvent voir cet espace.',
                privateNote: 'Seuls les membres invités peuvent voir cet espace.',
                dangerZone: 'Zone de danger',
                dangerZoneDescription: 'Actions irréversibles qui affectent votre espace.',
                deleteWorkspace: 'Supprimer l\'espace',
                deleteWorkspaceDescription: 'Supprime définitivement cet espace et tout son contenu.',
                deleteButton: 'Supprimer',
                saveSuccess: 'Paramètres enregistrés avec succès',
                saveError: 'Échec de l\'enregistrement des paramètres',
            },
            globalTeam: {
                title: 'Vue d\'ensemble de l\'équipe',
                subtitle: 'Tous les membres de vos espaces de travail.',
                search: 'Rechercher des membres...',
                workspaceFilter: 'Filtrer par espace',
                allWorkspaces: 'Tous les espaces',
                table: { name: 'Nom', workspace: 'Espace', role: 'Rôle', status: 'Statut', joinedAt: 'Rejoint' },
                memberCount: '{count} membre(s)',
                empty: { title: 'Aucun membre trouvé', description: 'Les membres apparaîtront ici lorsque vos espaces auront des membres.' },
            },
            globalTags: {
                title: 'Vue d\'ensemble des tags',
                subtitle: 'Tous les tags de votre organisation.',
                search: 'Rechercher des tags...',
                tagCount: '{count} tag(s)',
                table: { name: 'Tag', assetCount: 'Assets' },
                viewAssets: 'Voir les assets',
                empty: { title: 'Aucun tag trouvé', description: 'Les tags apparaîtront ici lorsque votre organisation aura des tags.' },
            },
            globalEmbed: {
                title: 'Paramètres d\'intégration',
                subtitle: 'Restrictions de domaines et configuration d\'intégration.',
                placeholder: { title: 'Configuration par espace', description: 'Les paramètres d\'intégration sont configurés individuellement pour chaque espace. Accédez aux paramètres d\'un espace pour gérer les restrictions de domaines.' },
            },
            sharesSettings: {
                title: 'Partages',
                subtitle: 'Gérez les liens de partage pour cet espace.',
                listTitle: 'Liens de partage',
                search: 'Rechercher des partages...',
                count: '{count} partage(s)',
                noResults: 'Aucun lien ne correspond à ces filtres.',
                clearFilters: 'Effacer les filtres',
                create: 'Créer un lien',
                pickTitle: 'Choisir ce que le lien partage',
                assetCount: '{count} asset | {count} assets',
                showMore: 'Afficher plus',
                sort: {
                    title: 'Trier par',
                    newest: 'Plus récents',
                    oldest: 'Plus anciens',
                    name: 'Nom',
                    views: 'Plus ouverts',
                    expiry: 'Expiration la plus proche',
                },
                error: {
                    title: 'Impossible de charger les liens de partage',
                    description: 'Vérifiez votre connexion et réessayez.',
                    retry: 'Réessayer',
                },
                table: {
                    name: 'Nom',
                    status: 'Statut',
                    assets: 'Assets',
                    views: 'Ouvertures',
                    createdAt: 'Créé le',
                    expiresAt: 'Expire le',
                    actions: 'Actions',
                },
                neverExpires: 'Jamais',
                neverExpiresLabelled: 'N\'expire jamais',
                expiresOn: 'Expire le {date}',
                expiredChip: 'Expiré',
                status: {
                    active: 'Actif',
                    inactive: 'Inactif',
                    expired: 'Expiré',
                    exhausted: 'Épuisé',
                },
                filter: {
                    all: 'Tous',
                },
                unlimited: 'Illimité',
                copyUrl: 'Copier le lien',
                copySuccess: 'Lien de partage copié dans le presse-papiers',
                edit: 'Modifier le partage',
                editSubtitle: 'Ajuster les paramètres de ce lien de partage',
                editSuccess: 'Partage mis à jour',
                editError: 'Échec de la mise à jour du partage',
                active: 'Actif',
                activeHint: 'Lorsque désactivé, le lien de partage ne sera plus accessible.',
                passwordUnchanged: 'Laisser vide pour conserver le mot de passe actuel',
                deleteConfirmTitle: 'Supprimer le partage',
                deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce partage ? Cela révoquera l\'accès pour toute personne utilisant ce lien.',
                deleteSuccess: 'Partage supprimé',
                deleteError: "Le partage n'a pas pu être supprimé.",
                copyError: "Le lien n'a pas pu être copié.",
                stats: {
                    button: 'Voir les statistiques',
                    title: 'Statistiques — {name}',
                    lifetimeViews: 'Ouvertures totales',
                    lifetimeViewsHint: 'Nombre de fois où le lien de partage a été ouvert (compté une fois par visiteur et par 24h, sur tout l\'historique), quel que soit le contenu consulté ensuite.',
                    viewsHint: 'Contenus réellement consommés sur la période : une lecture (>10s) pour les vidéos et audios, une ouverture pour les images.',
                    scopeNote: 'Engagement des lectures ouvertes via ce lien de partage.',
                    tabs: {
                        overview: 'Vue d’ensemble',
                        contents: 'Contenus',
                        email: 'E-mail',
                    },
                    contentsEmpty: 'Ce partage ne contient aucun contenu lisible.',
                    openContent: 'Accéder au contenu',
                    remainingViews: 'Ouvertures restantes',
                    lastViewed: 'Dernière ouverture',
                    recentVisits: 'Ouvertures récentes',
                    visitThroughLink: 'Lien du partage',
                    visitThroughRecipient: 'Lien personnel',
                    range: {
                        last7days: '7 derniers jours',
                        last30days: '30 derniers jours',
                        last90days: '90 derniers jours',
                    },
                    empty: {
                        title: 'Pas encore de données d’engagement',
                        description: 'Les statistiques détaillées sont enregistrées à partir de la mise en service de cette fonctionnalité. Partagez votre lien — les lectures apparaîtront ici.',
                    },
                    email: {
                        empty: {
                            title: 'Aucun e-mail envoyé',
                            description: 'Envoyez ce partage par e-mail : chaque destinataire reçoit un lien personnel, dont les ouvertures apparaîtront ici.',
                        },
                        kpi: {
                            sent: 'Envoyés',
                            delivered: 'Délivrés',
                            opened: 'Ouverts',
                            clicked: 'Cliqués',
                        },
                        sentCaption: '{count} destinataire | {count} destinataires',
                        deliverability: '{rate}% de délivrabilité',
                        opensTotal: '{count} ouvertures au total',
                        clicksTotal: '{count} clics au total',
                        funnelTitle: 'Entonnoir de l’e-mail',
                        recipientsTitle: 'Par destinataire',
                        col: {
                            recipient: 'Destinataire',
                            status: 'Statut',
                            opens: 'Ouvertures',
                            views: 'Vues',
                            lastEvent: 'Dernier événement',
                        },
                        status: {
                            pending: 'En attente',
                            sent: 'Envoyé',
                            delivered: 'Délivré',
                            opened: 'Ouvert',
                            clicked: 'Cliqué',
                            bounced: 'Rejeté',
                            failed: 'Échec',
                        },
                        footnote: 'Le suivi des ouvertures et clics est automatique — chaque destinataire ouvre un lien personnel.',
                        copyLink: 'Copier le lien personnel',
                        linkCopied: 'Lien personnel copié',
                    },
                },
                empty: {
                    title: 'Aucun partage',
                    description: 'Les liens de partage créés depuis cet espace apparaîtront ici.',
                },
            },
            deletionHistorySettings: {
                title: 'Historique des suppressions',
                subtitle: 'Consultez et restaurez les éléments récemment supprimés de cet espace.',
                overviewSubtitle: 'Consultez et restaurez les éléments récemment supprimés des espaces où vous pouvez les restaurer.',
                retentionWarning: 'Les éléments supprimés peuvent être restaurés pendant 30 jours. Passé ce délai, ils sont automatiquement supprimés définitivement et ne peuvent plus être restaurés.',
                billingNote: 'Les éléments de la corbeille restent facturés jusqu\'à leur suppression définitive, par vous ou automatiquement après 30 jours.',
                billingCost: 'Coût actuel de la corbeille : ≈ {amount} / mois.',
                purge: 'Supprimer définitivement',
                purgeConfirmTitle: 'Supprimer définitivement ?',
                purgeConfirmMessage: '« {name} » sera effacé définitivement, avec ses versions encodées et ses sous-titres. Cette action est irréversible et l\'élément ne pourra plus être restauré.',
                purgeSuccess: 'Élément supprimé définitivement.',
                purgeError: 'Impossible de supprimer définitivement cet élément.',
                purgeLocked: 'Cet élément a été validé dans le pool : seul un modérateur du pool peut le supprimer définitivement.',
                empty: 'Vider la corbeille',
                emptyConfirmTitle: 'Vider la corbeille ?',
                emptyConfirmMessage: 'Les {count} éléments de la corbeille seront effacés définitivement, avec leurs versions encodées et leurs sous-titres. Cette action est irréversible.',
                emptyConfirmSaving: 'Économie à partir de la prochaine mesure : ≈ {amount} / mois.',
                emptySuccess: '{count} élément(s) supprimé(s) définitivement.',
                emptyLocked: '{count} élément(s) validé(s) dans le pool ont été conservés pour ses modérateurs.',
                emptyError: 'Impossible de vider la corbeille.',
                search: 'Rechercher des éléments supprimés...',
                listTitle: 'Éléments supprimés',
                // Who put it in the trash when nobody did (`utils/trashReason.ts`).
                reasons: {
                    awaiting_credit_expired: 'Automatiquement : vidéo restée sept jours en attente de crédit',
                },
                emptyTitle: 'Aucun élément supprimé',
                emptyDescription: 'Les éléments supprimés de cet espace apparaîtront ici pendant 30 jours.',
                overviewEmptyDescription: 'Les éléments supprimés de ces espaces apparaîtront ici pendant 30 jours.',
                noResults: 'Aucun élément supprimé ne correspond à cette recherche.',
                columns: {
                    name: 'Nom',
                    type: 'Type',
                    deletedBy: 'Supprimé par',
                    deletedAt: 'Supprimé le',
                    daysRemaining: 'Temps restant',
                    workspace: 'Espace',
                    actions: 'Actions',
                },
                restore: 'Restaurer',
                restoreSuccess: 'Élément restauré avec succès.',
                restoreError: 'Échec de la restauration de l\'élément.',
                bulkRestore: 'Restaurer la sélection ({count})',
                bulkRestoreSuccess: '{count} élément(s) restauré(s) avec succès.',
                daysRemaining: '{count} jour(s) restant(s)',
                expired: 'Expiré',
                noLongerRestorable: 'Non restaurable',
                restoreConfirmTitle: 'Restaurer l\'élément',
                restoreConfirmMessage: 'Êtes-vous sûr de vouloir restaurer cet élément ? Il sera replacé à son emplacement d\'origine.',
                bulkRestoreConfirmTitle: 'Restaurer les éléments',
                bulkRestoreConfirmMessage: 'Êtes-vous sûr de vouloir restaurer {count} élément(s) ? Ils seront replacés à leurs emplacements d\'origine.',
            },
            playerLogo: {
                title: 'Logo du lecteur',
                description: 'Uploadez un logo à afficher sur tous les lecteurs intégrés de cet espace de travail.',
                orgDescription: 'Uploadez un logo par défaut pour tous les lecteurs intégrés de votre organisation. Les espaces peuvent le remplacer par leur propre logo.',
                upload: 'Uploader un logo (PNG, WebP)',
                remove: 'Supprimer',
                position: 'Position',
                positionTopLeft: 'Haut gauche',
                positionTopRight: 'Haut droite',
                positionBottomLeft: 'Bas gauche',
                positionBottomRight: 'Bas droite',
                opacity: 'Opacité',
                clickUrl: 'URL au clic',
                clickUrlDesc: 'Ouvre cette URL lorsque le logo est cliqué',
                helper: 'PNG ou WebP. Recommandé : fond transparent.',
                saved: 'Paramètres du logo sauvegardés',
                uploadError: 'Échec de l\'upload du logo',
                saveError: 'Échec de la sauvegarde des paramètres du logo',
                inheritedFromOrg: 'Utilise le logo défini dans les paramètres de l\'organisation. Uploadez un logo ici pour le remplacer dans cet espace.',
            },
            presetManagement: {
                title: 'Presets d\'intégration',
                description: 'Configurer les réglages et l\'apparence par défaut du lecteur pour cet espace',
                filterAll: 'Tous',
                filterVideo: 'Vidéo',
                filterAudio: 'Audio',
                filterImage: 'Image',
                filterDocument: 'Document',
                filterCollection: 'Collection',
                emptyState: {
                    title: 'Aucun preset',
                    description: 'Créez un preset depuis l\'onglet Développeur sur n\'importe quel fichier.',
                },
                createPreset: 'Créer un preset',
                orgPresets: 'Presets de l\'organisation',
                orgPresetsDesc: 'Ces presets sont partagés entre tous les espaces de travail',
                inheritedBadge: 'Hérité',
                summary: {
                    optionsChanged: '{count} option(s) personnalisée(s)',
                    noCustomOptions: 'Paramètres par défaut',
                },
                details: {
                    playback: 'Lecture',
                    display: 'Affichage',
                    features: 'Fonctionnalités',
                    appearance: 'Apparence',
                    dimensions: '{width} × {height}',
                    noLogo: 'Pas de logo',
                },
            },
        },
        members: {
            title: 'Membres',
            subtitle: 'Gérez les membres de l\'espace et leurs rôles',
            listTitle: 'Membres',
            invite: 'Ajouter un membre',
            inviteSuccess: 'Invitation envoyée avec succès',
            search: 'Rechercher des membres...',
            count: '{count} membre(s)',
            empty: {
                title: 'Aucun membre',
                description: 'Ajoutez des membres de l\'organisation pour collaborer sur cet espace.',
            },
            addModal: {
                memberLabel: 'Membre de l\'organisation',
                allSeated: 'Tous les membres de l\'organisation font déjà partie de cet espace.',
                personLabel: 'Membre ou adresse e-mail',
                seatHint: '{name} fait déjà partie de l\'organisation : l\'accès à cet espace lui est donné immédiatement.',
                inviteHint: 'Cette adresse ne fait pas partie de l\'organisation : une invitation lui sera envoyée par e-mail, et son acceptation la fera entrer dans l\'organisation comme membre, avec le rôle choisi ici dans cet espace.',
                alreadySeated: 'Cette personne fait déjà partie de cet espace.',
                cannotSeat: 'Vous n\'avez pas le droit d\'ajouter un membre à cet espace.',
                cannotInvite: 'Vous n\'avez pas le droit d\'inviter une personne extérieure à l\'organisation.',
                refusals: {
                    notSeatable: 'Aucun membre de l\'organisation ne correspond à cette adresse.',
                    invalidAddress: 'Adresse e-mail ou rôle invalide.',
                    inviteForbidden: 'Vous n\'avez pas le droit d\'envoyer cette invitation.',
                    workspaceGone: 'Cet espace n\'existe plus.',
                    alreadyMember: 'Cette adresse appartient déjà à un membre de l\'organisation : ajoutez-la directement à l\'espace.',
                    rateLimited: 'Trop d\'invitations envoyées : attendez quelques instants, ou réessayez demain si le quota quotidien de l\'organisation est atteint.',
                    noRelay: 'L\'envoi d\'e-mails est indisponible : l\'invitation n\'a pas été créée, car le lien ne voyage que dans le message.',
                },
            },
            pending: {
                title: 'Invitations en attente',
                note: 'Ces personnes ne font pas encore partie de l\'organisation. Le lien d\'invitation ne voyage que dans l\'e-mail : il n\'est affiché nulle part ici.',
                empty: 'Aucune invitation en attente.',
                invitedBy: 'Invitée par {name}',
                orgRole: 'Rejoindra l\'organisation comme {role}',
                table: {
                    email: 'Adresse',
                    workspace: 'Espace',
                    role: 'Rôle',
                    expires: 'Expire le',
                },
                actions: {
                    resend: 'Renvoyer l\'invitation',
                    cancel: 'Annuler l\'invitation',
                },
                toast: {
                    sent: 'Invitation envoyée à {email}',
                    resent: 'Invitation renvoyée : le lien précédent ne fonctionne plus',
                    resendError: 'Impossible de renvoyer l\'invitation',
                    resendRefused: 'Cette invitation ne peut plus être renvoyée telle quelle — le rôle qu\'elle propose n\'existe plus. Annulez-la et invitez de nouveau cette personne.',
                    cancelled: 'Invitation annulée',
                    cancelError: 'Impossible d\'annuler l\'invitation',
                    gone: 'Cette invitation n\'est plus en attente',
                },
            },
            status: {
                active: 'Actif',
                pending: 'En attente',
            },
            roles: {
                owner: 'Propriétaire',
                admin: 'Admin',
                editor: 'Éditeur',
                viewer: 'Lecteur',
            },
            filters: {
                role: 'Rôle',
                status: 'Statut',
                clear: 'Effacer les filtres',
            },
            stats: {
                total: 'Total des membres',
                active: 'Actifs',
                pending: 'En attente',
            },
            table: {
                name: 'Nom',
                role: 'Rôle',
                status: 'Statut',
                joinedAt: 'Rejoint',
                actions: 'Actions',
            },
            inviteModal: {
                title: 'Inviter un membre',
                emailLabel: 'Adresse email',
                emailPlaceholder: "nom{'@'}exemple.com",
                roleLabel: 'Rôle',
                submit: 'Envoyer l\'invitation',
            },
            roleSelect: {
                label: 'Rôle',
                ariaLabel: 'Rôle : {role}. Changer de rôle',
                builtinHeader: 'Rôles intégrés',
                customHeader: 'Rôles personnalisés',
                importedHeader: 'Rôles importés',
                importedLabel: 'Rôle importé — {list}',
                and: 'et',
                clauseSeparator: ' ; ',
                importedOrigin: "Nom d'origine : {name}",
                allows: "Voit l'espace, et peut {list}",
                onlyViews: "Voit l'espace et ce qu'il contient, sans rien modifier",
                confirm: {
                    title: 'Changer le rôle de {name} ?',
                    message: "Dans l'espace « {workspace} », {name} passera du rôle « {from} » au rôle « {to} ».",
                    gains: 'Pourra désormais',
                    loses: 'Ne pourra plus',
                    same: 'Les deux rôles donnent exactement les mêmes droits.',
                    submit: 'Changer le rôle',
                },
                success: 'Rôle de {name} changé : « {role} »',
            },
            delete: {
                title: 'Retirer le membre',
                warning: 'Ce membre perdra l\'accès à tous les fichiers de cet espace. Cette action est irréversible.',
                confirm: 'Retirer',
                success: 'Membre retiré avec succès',
                error: "Le membre n'a pas pu être retiré de l'espace.",
            },
        },
    },
    title: 'Fichiers',
    description: 'Gérez vos vidéos et fichiers',
    placeholder: 'Bientôt disponible...',
    actions: {
        preview: 'Aperçu',
        share: 'Partager',
        embed: 'Intégrer',
        more: 'Plus d\'actions',
    },
    miniPlayer: {
        collapse: 'Réduire',
        expand: 'Agrandir',
        fullscreen: 'Ouvrir en modal',
        minimize: 'Réduire en mini lecteur',
        close: 'Fermer le mini lecteur',
        play: 'Lecture',
        pause: 'Pause',
        openLarge: 'Ouvrir {name} en grand',
    },
    assetDetail: {
        tabs: {
            overview: 'Aperçu',
            metadata: 'Métadonnées',
            files: 'Fichiers',
            subtitles: 'Sous-titres',
            chapters: 'Chapitres',
            interactivity: 'Interactivité',
            analytics: 'Statistiques',
            contents: 'Contenus',
            developer: 'Développeur',
            history: 'Historique',
            shares: 'Partages',
        },
    },
    assetShares: {
        emptyTitle: 'Ce contenu n’a jamais été partagé',
        emptyDescription: 'Tous les liens qui ouvrent ce contenu — créés sur lui ou sur un dossier qui le contient, actifs ou non — s’afficheront ici.',
        create: 'Partager',
    },
    history: {
        emptyTitle: 'Aucune modification',
        emptyDescription: 'Les modifications de la fiche de ce contenu — faites directement ou proposées aux modérateurs du fond commun — s’afficheront ici.',
        error: {
            title: 'Impossible de charger l’historique',
            description: 'Une erreur est survenue en lisant l’historique de ce contenu.',
            retry: 'Réessayer',
        },
        state: {
            draft: 'Brouillon',
            submitted: 'En attente de validation',
            approved: 'Validé et appliqué',
            rejected: 'Refusé',
            abandoned: 'Abandonné',
            cancelled: 'Annulé',
            applied: 'Modifié',
        },
        madeBy: 'Par {name} le {date}',
        madeByKey: 'Par la clé API « {name} » le {date}',
        proposedBy: 'Proposé par {name} le {date}',
        decided: {
            approved: 'Validé par {name} le {date}',
            rejected: 'Refusé par {name} le {date}',
        },
        amendedBy: 'Retouché par {name} avant sa validation',
        noteLine: 'Message : « {reason} »',
        reasonLine: '« {reason} »',
        formerMember: 'un ancien membre',
        columns: {
            field: 'Champ',
            before: 'Avant',
            after: 'Après',
            proposed: 'Proposé',
        },
        fields: {
            name: 'Titre',
            description: 'Description',
            excerpt: 'Résumé',
            copyright_info: 'Droits',
            language: 'Langue',
            license_type: 'Licence',
            tags: 'Tags',
            metadata: 'Métadonnée',
        },
        empty: '(vide)',
        unknownTag: '(tag supprimé)',
        more: 'Voir plus',
    },
    trim: {
        launch: 'Rogner la vidéo',
        launchDesc: 'Couper le début ou la fin',
        title: 'Rogner la vidéo',
        lossless: 'Sans perte — l’original est conservé',
        destination: 'Destination',
        startLabel: 'Début',
        endLabel: 'Fin',
        startHandle: 'Début du rognage',
        endHandle: 'Fin du rognage',
        useCurrent: 'Utiliser la position actuelle',
        useCurrentStart: 'Placer le début à la position actuelle',
        useCurrentEnd: 'Placer la fin à la position actuelle',
        keptDuration: 'Durée conservée',
        removed: '−{duration} retirés',
        playSegment: 'Lire l’extrait',
        pausePreview: 'Pause',
        replay: 'Relire du début',
        destExisting: 'Modifier cette vidéo',
        destExistingHint: 'Instantané · garde les liens & intégrations',
        destNew: 'Nouvelle vidéo',
        destNewHint: 'Fichier indépendant, ré-encodé',
        soon: 'Bientôt',
        leak: 'Appliqué à la lecture in-app et aux intégrations. Le fichier source téléchargeable reste complet.',
        reset: 'Réinitialiser',
        cancel: 'Annuler',
        apply: 'Appliquer le rognage',
        applyWhere: 'Appliquer le rognage à…',
        applied: 'Rognage appliqué',
        applyError: 'Impossible d’appliquer le rognage',
        loadError: 'Impossible de charger la vidéo',
        clipNameSuffix: '{name} (extrait)',
        clipCreating: 'Création de l’extrait en cours…',
        clipError: 'Impossible de créer l’extrait',
        derivedFrom: 'Extrait de',
        trimmedTo: 'Rognée à {duration}',
        restoreOriginal: 'Rétablir l’original',
        restored: 'Original rétabli',
    },
    overview: {
        title: 'Aperçu',
        description: 'Informations générales sur ce fichier',
        playerPlaceholder: 'Lecteur (bientôt disponible)',
        form: {
            title: 'Informations générales',
            name: 'Nom',
            description: 'Description',
            slug: 'Slug',
            slugEdit: 'Modifier le slug',
            slugGenerate: 'Générer depuis le nom',
            slugNone: 'Aucun slug. « Générer depuis le nom » en propose un.',
            slugWarning: 'Attention, si ce contenu est déjà publié, la modification du slug modifie son URL. Êtes-vous sûr de vouloir le modifier ?',
            tags: 'Tags',
            noTags: 'Aucun tag',
            tagsPlaceholder: 'Rechercher ou ajouter des tags...',
            tagsPlaceholderRestricted: 'Rechercher des tags...',
            manageTags: 'Gérer',
            createTag: 'Créer le tag : {name}',
            cancel: 'Annuler',
            tagCreateError: 'Impossible de créer le tag',
        },
        details: {
            title: 'Détails du fichier',
            subtitle: 'Métadonnées techniques',
            addedOn: 'Ajouté le',
            duration: 'Durée',
            format: 'Format',
            size: 'Taille',
            itemCount: 'Éléments',
            oneItem: '1 élément',
            multipleItems: '{count} éléments',
            sizeUnits: {
                bytes: 'o',
                kb: 'Ko',
                mb: 'Mo',
                gb: 'Go',
                tb: 'To',
            },
            status: 'Statut',
            owner: 'Propriétaire',
        },
        aiAssistant: {
            title: 'Assistant IA',
            subtitles: 'Générer des sous-titres',
            chapters: 'Chapitrer cette vidéo',
            summarize: 'Résumer le contenu',
            aiWriting: 'Rédiger titres et descriptions',
            seoKeywords: 'Générer des mots-clés SEO',
        },
        channelStatus: {
            title: 'Publié dans une chaîne | Publié dans {count} chaînes',
            status: {
                published: 'Publié',
                scheduled: 'Programmé',
                draft: 'Brouillon',
                archived: 'Retiré',
            },
        },
        quickActions: {
            title: 'Actions rapides',
            subtitle: 'Ajoutez, partagez ou exportez en un clic',
            addToCollection: 'Ajouter à une collection',
            addToCollectionDesc: 'Organiser dans une playlist',
            newCollection: 'Nouvelle collection',
            noCollectionTitle: 'Aucune collection dans cet espace',
            noCollectionDescription: 'Créez une collection pour y ajouter ce média.',
            createClip: 'Créer un clip',
            createClipDesc: 'Clip court pour les réseaux sociaux',
            addToChannel: 'Ajouter à une chaîne',
            addToChannelDesc: 'Publier sur un portail',
            subtitles: 'Générer des sous-titres',
            subtitlesDesc: 'Générer avec Scribe AI',
            aiWriting: 'Rédaction IA',
            aiWritingDesc: 'Générer titres, descriptions et plus',
            download: 'Télécharger',
            downloadDesc: 'Obtenir le fichier source',
            addContent: 'Ajouter du contenu',
            addContentDesc: 'Sélectionner des éléments',
        },
        embed: {
            title: 'Intégration',
            subtitle: 'Intégrez cet asset sur votre site web',
            embedUrl: 'URL d\'intégration',
            iframeCode: 'Code iframe',
            copyUrl: 'Copier l\'URL',
            copyIframe: 'Copier l\'iframe',
            copied: 'Copié !',
            loading: 'Chargement...',
            error: 'Impossible de charger les informations d\'intégration',
        },
        error: {
            title: 'Erreur de chargement',
            description: 'Impossible de charger les informations de l\'asset',
            retry: 'Réessayer',
        },
        // A video measured and not encoded for want of credit (`AwaitingCreditPanel.vue`).
        awaitingCredit: {
            title: 'En attente de crédit',
            description: 'Votre vidéo est bien arrivée, mais le crédit de l\'organisation ne couvre pas son premier mois de stockage : elle n\'est pas encore encodée. Rechargez votre crédit, et l\'encodage reprend de lui-même dans les minutes qui suivent.',
            trash: 'Sans recharge, au bout de sept jours d\'attente, la vidéo revient à sa version précédente si elle en a une qui se lit, et part à la corbeille sinon.',
            topUp: 'Rechargez votre crédit',
            member: 'Seuls les responsables de la facturation peuvent recharger le crédit : demandez à l\'un d\'eux.',
        },
        encoding: {
            title: {
                video: 'Votre vidéo est en cours de préparation',
                audio: 'Votre fichier audio est en cours de préparation',
                image: 'Votre image est en cours de traitement',
                document: 'Votre document est en cours de traitement',
                default: 'Votre fichier est en cours de préparation',
            },
            description: {
                video: 'Nous encodons votre fichier pour qu\'il puisse être lu sur tous les appareils. Cela peut prendre quelques minutes pour les vidéos longues.',
                audio: 'Nous préparons votre fichier audio pour qu\'il puisse être lu sur tous les appareils.',
                image: 'Nous analysons votre image et générons les aperçus.',
                document: 'Nous traitons votre document et générons les aperçus.',
                default: 'Nous préparons votre fichier.',
            },
            hint: 'Vous pouvez quitter cette page — le traitement continuera en arrière-plan.',
            pending: 'En file d\'attente',
            uploading: 'Envoi du fichier',
            fetchingSource: 'Téléchargement depuis le lien',
            extractingMetadata: 'Analyse du fichier',
            extractingText: 'Lecture du texte',
            generatingThumbnails: 'Génération des aperçus',
            drawingWaveform: 'Tracé de la forme d\'onde',
            buildingFilmstrip: 'Création de la bande d\'aperçus',
            encoding: 'Encodage pour le streaming',
        },
        emptyCollection: {
            title: 'Cette collection est vide',
            description: 'Ajoutez du contenu pour voir un aperçu ici.',
        },
        previewNotAvailable: 'Aperçu non disponible pour ce type de fichier',
        saveSuccess: 'Modifications enregistrées',
        saveError: 'Échec de l\'enregistrement',
        thumbnails: {
            title: 'Miniatures',
            add: 'Ajouter',
            import: 'Importer une image',
            capture: 'Capturer depuis la vidéo',
            captureModal: {
                title: 'Capturer une miniature',
                description: 'Naviguez dans la vidéo et capturez l\'image souhaitée.',
                generate: 'Capturer',
                play: 'Lecture',
                pause: 'Pause',
                stepBack: 'Image précédente',
                stepForward: 'Image suivante',
                loadingVideo: 'Chargement de la vidéo...',
                loadError: 'Échec du chargement de la vidéo',
                retry: 'Réessayer',
                mute: 'Couper le son',
                unmute: 'Activer le son',
                queueFull: 'La file de traitement est saturée. Réessayez dans quelques minutes.',
                capturing: 'Capture de l\'image en cours…',
            },
            empty: 'Aucune miniature disponible',
            recommendation: 'Recommandé : {width}×{height} ({ratio}), {formats}, max {maxSize} Mo',
            selected: 'Sélectionnée',
            effective: 'Image affichée par défaut',
            download: 'Télécharger',
            delete: 'Supprimer',
            deleteConfirm: {
                title: 'Supprimer la miniature',
                message: 'Êtes-vous sûr de vouloir supprimer cette miniature ? Cette action est irréversible.',
            },
            deleteSuccess: 'Miniature supprimée',
            deleteError: 'Échec de la suppression de la miniature',
            selectSuccess: 'Miniature sélectionnée',
            selectError: 'Échec de la sélection de la miniature',
            uploadSuccess: 'Miniature importée',
            uploadError: 'Échec de l\'import de la miniature',
            fileTooLarge: 'L\'image est trop volumineuse. La taille maximale est de 10 Mo.',
            invalidFileType: 'Type de fichier invalide. Seules les images JPEG, PNG et WebP sont acceptées.',
            generateSuccess: 'Génération de la miniature lancée',
            captureSuccess: 'Miniature capturée. Enregistrez pour l\'appliquer.',
            generateError: 'Échec de la génération de la miniature',
        },
    },
    metadata: {
        title: 'Métadonnées',
        description: 'Gérez les métadonnées personnalisées de cet asset',
        emptyTitle: 'Aucun schéma de métadonnées',
        emptyDescription: 'Aucun champ de métadonnées personnalisé n\'a été défini pour ce type d\'asset. Contactez votre administrateur pour configurer les schémas de métadonnées.',
        viewDetail: 'Détails',
        valueRefused: 'Les métadonnées n\'ont pas été enregistrées : une valeur a été refusée. Vérifiez les champs modifiés.',
        ideoCompletionFailed: 'La fiche n\'a pas pu être lue : les champs qu\'elle complète sont restés tels quels.',
        error: {
            title: 'Échec du chargement des métadonnées',
            description: 'Une erreur s\'est produite lors du chargement des métadonnées. Veuillez réessayer.',
            retry: 'Réessayer',
        },
    },
    folder: {
        root: 'Racine',
        browse: 'Parcourir le dossier',
        createTitle: 'Créer un dossier',
        name: 'Nom du dossier',
        selectionHint: '{count} élément sélectionné sera déplacé dans ce dossier | {count} éléments sélectionnés seront déplacés dans ce dossier',
        selectFolder: 'Sélectionner un dossier',
        searchPlaceholder: 'Rechercher des dossiers...',
        selectWorkspaceFirst: "Sélectionnez d'abord un espace de travail",
    },
    transfers: {
        drawer: {
            title: 'Transferts',
        },
        tabs: {
            uploads: 'Envois',
            exports: 'Exports',
        },
        exports: {
            empty: 'Aucun export',
            emptyHelper: 'Vos archives ZIP et vos vidéos sous-titrées apparaîtront ici',
            inProgress: '{count} export en cours | {count} exports en cours',
            readyOne: 'Votre export est prêt',
            readyMany: '{count} exports sont prêts',
            failedCount: 'Un export a échoué | {count} exports ont échoué',
            preparing: 'Préparation…',
            ready: 'Prêt',
            failed: 'Échec',
            download: 'Télécharger',
            later: 'Plus tard',
            dismiss: 'Ignorer',
            view: 'Voir',
            retry: 'Réessayer',
            remove: 'Retirer',
            errorGeneric: 'L\'export a échoué.',
            errorNetwork: 'Connexion perdue pendant le suivi de l\'export.',
            phase: {
                compressing: 'Compression',
            },
            source: {
                zip: 'Médiathèque',
                'burned-video': 'Scribe',
                clip: 'Clips',
            },
            kind: {
                zip: 'Archive ZIP',
                'burned-video': 'Vidéo sous-titrée',
                clip: 'Clip',
            },
        },
    },
    upload: {
        fab: 'Envoyer des fichiers',
        openDrawer: 'Voir les envois en cours',
        drawer: {
            title: 'Envois',
            clearCompleted: 'Effacer les terminés',
            clearFailed: 'Effacer les échoués',
            clearAll: 'Tout effacer',
            cancelAllActive: 'Tout annuler',
            clearInactive: 'Effacer l\'historique',
            empty: 'Aucun envoi',
            emptyHelper: 'Déposez des fichiers ici ou utilisez le bouton d\'envoi',
            keepTabOpenWarning: 'Gardez cet onglet ouvert jusqu\'à la fin des envois. Le fermer ou le rafraîchir interrompra les transferts.',
        },
        dropZone: {
            clickOrDrag: 'Cliquez ou déposez des fichiers ici',
            helper: 'Taille maximale : {size} Mo',
            dropHere: 'Déposez les fichiers ici !',
        },
        dropOverlay: {
            title: 'Déposez les fichiers pour les envoyer',
            subtitle: 'Les fichiers seront envoyés dans l\'espace de travail actuel',
        },
        workspacePicker: {
            title: 'Choisir un espace de travail',
            hint: 'Dans quel espace de travail envoyer ce fichier ? | Dans quel espace de travail envoyer ces {count} fichiers ?',
            confirm: 'Envoyer',
            empty: 'Vous n\'avez aucun espace où envoyer ce fichier. | Vous n\'avez aucun espace où envoyer ces {count} fichiers.',
            emptyAction: 'Créer un espace',
        },
        miniDock: {
            uploading: '{count} envoi en cours | {count} envois en cours',
            keepTabOpenWarning: 'Ne fermez pas et ne rafraîchissez pas cet onglet — les envois seraient interrompus.',
        },
        progress: {
            files: 'fichiers',
            speed: 'Vitesse',
            eta: 'Temps restant',
        },
        item: {
            pending: 'En attente...',
            uploading: 'Envoi en cours',
            paused: 'En pause',
            completed: 'Terminé',
            failed: 'Échec',
            cancelled: 'Annulé',
            queued: 'En attente',
        },
        actions: {
            pause: 'Pause',
            resume: 'Reprendre',
            cancel: 'Annuler',
            retry: 'Réessayer',
            remove: 'Supprimer',
            topUp: 'Rechargez votre crédit',
        },
        errors: {
            fileTooLarge: 'Le fichier dépasse la taille maximale de {size} Mo',
            queueFull: 'La file d\'envoi est pleine ({max} fichiers max). Attendez la fin de certains envois avant d\'en ajouter d\'autres.',
            queueWouldExceed: 'Impossible d\'ajouter les fichiers — la limite est de {max} éléments.',
            notAllowed: 'Votre rôle dans cet espace de travail ne permet pas d\'y ajouter des fichiers',
        },
        failure: {
            network: 'La connexion a été coupée pendant l\'envoi. Vérifiez votre réseau puis réessayez : le transfert reprendra là où il s\'est arrêté.',
            interrupted: 'Le transfert s\'est interrompu en route. Réessayez : il reprendra à partir de ce que le serveur a déjà reçu.',
            tooLarge: 'Ce fichier dépasse la taille que nous acceptons.',
            refused: 'Le serveur a refusé ce fichier. Vérifiez qu\'il s\'agit bien d\'un média lisible.',
            forbidden: 'Vous n\'avez plus le droit d\'ajouter des fichiers dans cet espace. Votre session a peut-être expiré : reconnectez-vous.',
            destinationGone: 'L\'espace, le dossier ou le média où allait ce fichier n\'existe plus. Envoyez-le ailleurs.',
            rateLimited: 'Trop de demandes en même temps. Réessayez dans un moment.',
            creditsExhausted: 'Le crédit de l\'organisation est épuisé, ou ne couvre pas le premier mois de stockage de ce fichier, débité à l\'envoi. Rechargez votre crédit : l\'envoi repart ensuite.',
            budgetExceeded: 'Une limite de dépenses fixée pour l\'organisation bloque cet envoi. La personne qui gère la facturation peut la relever.',
            session: 'L\'envoi a expiré ou a été interrompu côté serveur. Relancez-le depuis le début.',
            timedOut: 'Le serveur a cessé d\'attendre avant la fin de l\'envoi : la connexion ou le serveur était trop lent. Réessayez dans un moment.',
            server: 'Notre serveur n\'a pas pu recevoir le fichier. Réessayez dans quelques instants ; si le problème persiste, contactez le support.',
        },
    },
    processingFailure: {
        truncated: 'Fichier incomplet : il s\'arrête avant la fin, sans doute un export ou une copie interrompus. Il faut le réexporter puis l\'importer à nouveau.',
        unreadable: 'Fichier illisible : il est abîmé, ou dans un format non pris en charge. Un MP4 (H.264) ou un MP3 passe à tous les coups.',
        noPicture: 'Aucune image dans ce fichier vidéo. Si c\'est un son, il s\'importe comme fichier audio.',
        noSound: 'Aucune piste sonore dans ce fichier audio.',
        quarantined: 'Fichier bloqué par le contrôle de sécurité : il ne peut pas être traité.',
        timeout: 'Traitement interrompu, il prenait trop de temps. Un fichier plus court ou plus léger passera.',
        transfer: 'Le lien n\'a pas pu être téléchargé : il doit être public et toujours valide.',
        sourceUnavailable: 'Le problème vient de chez nous, pas de votre fichier : nous n\'avons pas pu le relire sur notre stockage. Le support peut relancer le traitement, avec le nom du média.',
        internal: 'Une erreur de notre côté a empêché le traitement. Le support peut le relancer, avec le nom du média.',
        unknown: 'Le traitement a échoué. Un nouvel import règle souvent le problème ; sinon, le support peut aider.',
    },
    collection: {
        createTitle: 'Créer une collection',
        name: 'Nom de la collection',
        selectionHint: '{count} élément sélectionné sera ajouté à cette collection | {count} éléments sélectionnés seront ajoutés à cette collection',
        selectType: 'Type de collection',
        types: {
            videos: 'Vidéos',
            audios: 'Audios',
            images: 'Images',
            documents: 'Documents',
        },
        createSuccess: 'Collection créée',
        createError: 'Échec de la création de la collection',
    },
    sort: {
        title: 'Trier',
        relevance: 'Pertinence',
        nameAsc: 'Nom (A → Z)',
        nameDesc: 'Nom (Z → A)',
        createdDesc: 'Date d\'ajout (récents)',
        createdAsc: 'Date d\'ajout (anciens)',
    },
    search: 'Rechercher...',
    searchBar: {
        recent: 'Récentes',
        saveSearch: 'Enregistrer la recherche',
        searchName: 'Nom de la recherche',
        emptyHint: 'Tapez pour rechercher vos fichiers',
        toSearch: 'pour rechercher',
        toClose: 'pour fermer',
        filtersOnly: 'Filtres uniquement',
        filtersCount: '{count} filtre(s)',
        currentSearch: 'Recherche actuelle',
        includedFilters: 'Filtres inclus',
        hideFolders: 'Masquer les dossiers',
        resetSearch: 'Réinitialiser',
    },
    searchResultsBar: {
        resultCount: '{count} résultat | {count} résultats',
        searching: 'Recherche en cours...',
        clearAll: 'Tout effacer',
    },
    breadcrumb: {
        folderCount: '{count} dossier | {count} dossiers',
        fileCount: '{count} fichier | {count} fichiers',
    },
    filters: 'Filtres',
    viewGrid: 'Vue grille',
    viewList: 'Vue liste',
    settings: {
        title: 'Options d\'affichage',
        subtitle: 'Personnalisez l\'affichage des fichiers',
        options: 'Options',
        appearance: 'Apparence',
        thumbnails: 'Vignettes',
        organization: 'Organisation',
        viewMode: 'Mode d\'affichage',
        grid: 'Grille',
        list: 'Liste',
        density: 'Densité',
        compact: 'Compact',
        comfortable: 'Confort',
        spacious: 'Spacieux',
        thumbnailFormat: 'Format des vignettes',
        landscape: 'Paysage',
        square: 'Carré',
        portrait: 'Portrait',
        thumbnailFit: 'Ajustement des vignettes',
        cover: 'Remplir',
        contain: 'Ajuster',
        foldersDisplay: 'Affichage des dossiers',
        flattenFolders: 'Ignorer les dossiers',
        flattenFoldersHint: 'Affiche tous les fichiers sans hiérarchie de dossiers',
        displayedInfo: 'Informations affichées',
        default: 'Par défaut',
        custom: 'Personnalisé',
        defaultFieldsInclude: 'Champs inclus par défaut :',
        fields: {
            type: 'Type',
            duration: 'Durée',
            size: 'Taille',
            createdDate: 'Date de création',
            owner: 'Propriétaire',
            tags: 'Tags',
            dimensions: 'Dimensions',
            shareLink: 'Lien de partage',
        },
    },
    filter: {
        title: 'Filtres',
        subtitle: 'Filtrer les fichiers par critères',
        fileType: 'Type de fichier',
        fileTypes: 'Types de fichiers',
        video: 'Vidéo',
        image: 'Image',
        audio: 'Audio',
        document: 'Document',
        archive: 'Archive',
        collections: 'Collections',
        includeCollections: 'Inclure les collections associées',
        status: 'Statut',
        statusCreated: 'Créé',
        statusProcessing: 'En traitement',
        statusReady: 'Prêt',
        statusError: 'Erreur',
        statusArchived: 'Archivé',
        visibility: 'Visibilité',
        visibleOnly: 'Visible uniquement',
        sensitiveOnly: 'Contenu sensible uniquement',
        tags: 'Tags',
        selectTags: 'Sélectionner des tags',
        workspaces: 'Espaces',
        selectWorkspaces: 'Sélectionner des espaces',
        workspacesCount: '{count} espace | {count} espaces',
        clearAll: 'Tout effacer',
        collectionType: 'Type de collection',
        collectionTypes: {
            videos: 'Vidéos',
            audios: 'Audios',
            images: 'Images',
            documents: 'Documents',
        },
        customMetadata: 'Métadonnées personnalisées',
        subtitles: 'Sous-titres',
        anySubtitles: 'Tous',
        withSubtitles: 'Avec sous-titres',
        withoutSubtitles: 'Sans sous-titres',
        reset: 'Réinitialiser',
        saveFilters: 'Enregistrer',
        activeCount: '{count} filtre(s) actif(s)',
        noActiveFilters: 'Aucun filtre actif',
        favorites: 'Recherches sauvegardées',
    },
    savedSearch: {
        title: 'Recherches sauvegardées',
        subtitle: 'Accès rapide à vos recherches sauvegardées',
        count: '{count} recherche(s) sauvegardée(s)',
        list: 'Vos recherches sauvegardées',
        listDescription: 'Cliquez pour appliquer les filtres',
        empty: 'Aucune recherche sauvegardée',
        emptyHint: 'Sauvegardez votre recherche actuelle pour y accéder rapidement plus tard',
        emptyAction: 'Cliquez sur l\'étoile dans la barre de recherche',
        untitled: 'Recherche sans nom',
        rename: 'Renommer la recherche',
        newName: 'Nouveau nom',
        filtersCount: '{count} filtre | {count} filtres',
        noFilters: 'Aucun filtre',
        searchQuery: 'Recherche : {query}',
        resultCount: '{count} résultat | {count} résultats',
        saveSuccess: 'Recherche sauvegardée',
        saveError: 'Impossible de sauvegarder la recherche',
        renameSuccess: 'Recherche renommée',
        renameError: 'Impossible de renommer la recherche',
        deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette recherche sauvegardée ?',
        deleteSuccess: 'Recherche supprimée',
        deleteError: 'Impossible de supprimer la recherche',
        duplicateName: 'Une recherche sauvegardée avec ce nom existe déjà',
    },
    loadMore: '{loaded} sur {total}',
    new: 'Nouveau',
    newDisabledTooltip: 'Sélectionnez un espace pour créer de nouveaux éléments',
    selected: 'sélectionné(s)',
    menu: {
      createClip: 'Créer un clip',
        notAllowed: 'Votre rôle ne le permet pas',
        open: 'Ouvrir',
        openInNewTab: 'Ouvrir dans un nouvel onglet',
        rename: 'Renommer',
        move: 'Déplacer',
        share: 'Partager',
        download: 'Télécharger',
        delete: 'Supprimer',
        copyFrom: 'Importer les infos d\'un autre asset',
    },
    permissions: {
        editRequired: 'Vous n\'avez pas la permission de modifier cet asset',
        subtitleEditRequired: 'Vous n\'avez pas la permission de modifier les sous-titres de cet asset',
        subtitleDeleteRequired: 'Vous n\'avez pas la permission de supprimer les sous-titres de cet asset',
        deleteRequired: 'Vous n\'avez pas la permission de supprimer cet asset',
        trashRequired: 'Vous n\'avez pas la permission de mettre cet asset à la corbeille',
        createRequired: 'Vous n\'avez pas la permission de créer des assets',
        moderateRequired: 'Vous n\'avez pas la permission de modérer les assets',
        exportRequired: 'Vous n\'avez pas la permission d\'exporter les données',
        analyticsRequired: 'Vous n\'avez pas la permission de voir les analytics',
    },
    copyFrom: {
        dialogTitle: 'Importer les infos d\'un autre asset',
        fields: {
            title: 'Titre',
            description: 'Description',
            tags: 'Tags',
            metadata: 'Métadonnées',
        },
        noValue: 'Aucune valeur dans la source',
        newTags: '{count} nouveau tag sera ajouté | {count} nouveaux tags seront ajoutés',
        sourceTagsCount: '{count} tag dans la source | {count} tags dans la source',
        noNewTags: 'Tous les tags sont déjà présents',
        tagsMode: {
            add: 'Ajouter aux tags existants',
            replace: 'Remplacer les tags existants',
        },
        metadataCount: '{count} champ sera mis à jour | {count} champs seront mis à jour',
        noMetadata: 'Aucun champ de métadonnées correspondant',
        apply: 'Appliquer',
        applied: 'Informations copiées avec succès',
        metadataApplied: 'Métadonnées mises à jour',
        tooLongSkipped: 'Ce champ est trop long pour être copié : {fields} | Ces champs sont trop longs pour être copiés : {fields}',
        metadataError: 'Échec de la mise à jour des métadonnées',
        fetchError: 'Impossible de charger l\'asset source',
    },
    delete: {
        title: 'Supprimer',
        message: 'Cet élément sera déplacé vers la corbeille. Vous pourrez le restaurer pendant 30 jours ; il reste facturé jusqu\'à sa suppression définitive, automatique après 30 jours.',
        folderMessage: 'Ce dossier et tout son contenu seront déplacés vers la corbeille. Vous pourrez les restaurer pendant 30 jours ; ils restent facturés jusqu\'à leur suppression définitive, automatique après 30 jours.',
        bulkMessage: 'Ces éléments seront déplacés vers la corbeille. Vous pourrez les restaurer pendant 30 jours ; ils restent facturés jusqu\'à leur suppression définitive, automatique après 30 jours.',
        bulkMessageWithFolders: 'Ces éléments (y compris les dossiers et leur contenu) seront déplacés vers la corbeille. Vous pourrez les restaurer pendant 30 jours ; ils restent facturés jusqu\'à leur suppression définitive, automatique après 30 jours.',
        allWorkspacesNote: 'Les éléments seront supprimés de leurs espaces de travail respectifs.',
        multipleItems: '{count} éléments',
        publishedOnTitle: 'Ce média est publié sur 1 chaîne | Ce média est publié sur {count} chaînes',
        bulkPublishedOnTitle: 'Cette sélection est publiée sur 1 chaîne | Cette sélection est publiée sur {count} chaînes',
        publishedOnEffect: 'Le supprimer l\'y rendra invisible.',
        bulkPublishedOnEffect: 'Les supprimer les y rendra invisibles.',
        publishedOnMore: 'et 1 autre chaîne | et {count} autres chaînes',
        publishedOnRecovery: 'Le contenu repasse en brouillon : il disparaît du site public, mais les commentaires et les achats sont conservés. Vous pourrez le republier à la main après avoir restauré le média depuis la corbeille, dans les 30 jours.',
        usagesUnavailable: 'Impossible de vérifier où ce média est publié. Vous pouvez continuer, mais nous ne pouvons pas vous dire ce qui sera retiré.',
        success: 'Élément supprimé',
        successMultiple: '{count} éléments supprimés',
        partialSuccess: '{deleted} supprimés, {failed} échoués',
        error: 'Échec de la suppression',
    },
    addToChannel: {
        title: 'Ajouter à une chaîne',
        menuLabel: 'Ajouter à une chaîne',
        description: 'Sélectionnez la chaîne sur laquelle publier ce contenu.',
        selectChannel: 'Sélectionner une chaîne',
        noChannels: 'Aucune chaîne disponible',
        channelsError: 'Impossible de charger les chaînes.',
        next: 'Suivant',
        back: 'Retour',
        publish: 'Publier',
        success: 'Publié sur la chaîne | {count} contenu publié sur la chaîne | {count} contenus publiés sur la chaîne',
        error: 'La publication sur la chaîne a échoué',
        partialSuccess: '{success} contenu(s) publié(s) — {failed} en échec',
        scheduleTitle: 'Programmer la publication',
        scheduleDateLabel: 'Date de publication',
        scheduleBtn: 'Programmer',
        showPreview: 'Aperçu avant publication',
        showPreviewHint: 'Afficher un aperçu même avant la date de publication.',
        alreadyPublishedIn: 'Ce média est déjà publié dans :',
        alreadyAdded: 'Déjà ajoutée',
        partiallyAdded: '{done}/{total} déjà ajoutés',
        viewItem: 'Voir dans la chaîne',
        accessDescription: 'Qui pourra atteindre ce contenu sur la chaîne.',
        access: {
            public: {
                label: 'Public',
                hint: 'Tout le monde, sans compte.',
            },
            authenticated: {
                label: 'Visiteurs connectés',
                hint: 'Toute personne ayant franchi la porte de la chaîne.',
            },
            restricted: {
                label: 'Restreint',
                hint: 'Seulement les membres à qui la chaîne l\'a ouvert.',
            },
        },
        isListed: 'Visible dans le catalogue',
        isListedHint: 'Apparaît dans les pages de navigation de la chaîne.',
        isShownLocked: 'Afficher verrouillé',
        isShownLockedHint: 'La page reste visible, sans lecture, pour qui n\'y a pas accès.',
        requiresAccessRequest: 'Sur demande',
        requiresAccessRequestHint: 'Un membre doit demander l\'accès ; le contenu s\'affiche verrouillé.',
        sale: {
            description: 'Comment cette publication se vend sur la chaîne. Les prix se saisissent TTC, comme l\'acheteur les paie.',
            sell: 'Vendre cette publication',
            sellHint: 'Elle est réservée aux abonnés et aux acheteurs, et s\'affiche verrouillée pour les autres.',
            exclTax: 'HT',
            priceExclTax: 'Prix HT',
            priceInclTax: 'Prix public TTC',
            inclTax: 'TTC',
            breakdown: 'Soit {net} HT + {vat} de TVA ({rate}), estimée au taux français.',
            priceMinimum: 'Le prix minimum est de {amount} TTC',
            estimate: 'Soit environ {amount} TTC pour un spectateur en France (TVA {rate}, estimation : la taxe exacte est calculée au paiement).',
            noVat: 'TVA non applicable : le spectateur paie ce prix.',
            invalid: 'Choisissez au moins un abonnement ou un prix, et un prix d\'au moins 2 € TTC pour chaque mode activé.',
            accessNote: 'Une publication vendue est restreinte : l\'accès choisi à l\'étape précédente est remplacé.',
            plans: {
                title: 'Incluse dans les abonnements',
                every: 'Dans tous les abonnements de la chaîne',
                none: 'Cette chaîne n\'a encore aucun abonnement à choisir.',
                fullAccess: 'Déjà incluse dans les abonnements qui ouvrent tout le catalogue : {plans}.',
            },
            purchase: {
                title: 'Achat à l\'unité',
                name: 'Acheter',
            },
            rental: {
                title: 'Location',
                name: 'Louer {duration}',
                duration: 'Durée',
                units: {
                    hour: 'Heures',
                    day: 'Jours',
                    month: 'Mois',
                    year: 'Années',
                },
                counted: {
                    hour: '{count} heure',
                    hours: '{count} heures',
                    day: '{count} jour',
                    days: '{count} jours',
                    month: '{count} mois',
                    months: '{count} mois',
                    year: '{count} an',
                    years: '{count} ans',
                },
            },
        },
        categoriesDescription: 'Classez la publication dans le catalogue de la chaîne.',
        categories: 'Catégories',
        noCategories: 'Cette chaîne n\'a aucune catégorie',
        primaryCategory: 'Catégorie principale',
        steps: {
            channel: 'Chaîne',
            visibility: 'Accès',
            sale: 'Vente',
            categories: 'Catégories',
        },
        processing: {
            creating: 'Création des publications...',
            configuring: 'Application des réglages...',
            pricing: 'Mise en vente...',
            publishing: 'Mise en ligne...',
        },
        skipped: {
            absent: 'Un média est introuvable | {count} médias sont introuvables',
            not_ready: 'Un média n\'est pas encore prêt | {count} médias ne sont pas encore prêts',
            wrong_type: 'Un média n\'est pas d\'un type qu\'une chaîne publie | {count} médias ne sont pas d\'un type qu\'une chaîne publie',
            already_published: 'Un média est déjà publié sur cette chaîne | {count} médias sont déjà publiés sur cette chaîne',
            mixed: 'Un média n\'a pas pu être publié | {count} médias n\'ont pas pu être publiés',
        },
    },
    listViewComingSoon: 'Vue liste bientôt disponible',
    createFolder: 'Créer un dossier',
    createFolderDescription: 'Organisez vos fichiers',
    createCollection: 'Créer une collection',
    createCollectionDescription: 'Regroupez vos médias',
    uploadFile: 'Importer des fichiers',
    uploadFileDescription: 'Ajoutez vos médias',
    empty: {
        title: 'Cet espace est vide',
        titleFolder: 'Ce dossier est vide',
        description: 'Commencez par organiser vos fichiers en créant des dossiers ou des collections',
        descriptionFolder: 'Ajoutez des fichiers ou créez des sous-dossiers pour organiser votre contenu',
        noResults: 'Aucun résultat trouvé',
        noResultsDescription: 'Essayez de modifier vos filtres ou votre recherche pour trouver ce que vous cherchez',
        recentTitle: 'Rien de nouveau depuis {days} jours',
        recentDescription: 'Les médias ajoutés à cet espace apparaissent ici pendant {days} jours.',
        recentDescriptionAll: 'Les médias ajoutés à vos espaces apparaissent ici pendant {days} jours.',
        uploadTitle: 'Importer des fichiers',
        uploadDescription: 'Ajoutez vos médias',
        folderTitle: 'Créer un dossier',
        folderDescription: 'Organisez vos fichiers',
        collectionTitle: 'Créer une collection',
        collectionDescription: 'Regroupez vos médias',
        dragHint: 'Vous pouvez aussi glisser-déposer des fichiers n\'importe où sur cette page',
        readOnly: 'Vous consultez cet espace en lecture. Pour y ajouter des fichiers, demandez à un administrateur de l\'espace.',
        clearFilters: 'Réinitialiser les filtres',
    },
    rename: {
        title: 'Renommer',
        newName: 'Nouveau nom',
        success: 'Renommé avec succès',
        error: 'Impossible de renommer',
    },
    download: {
        error: 'Impossible de télécharger le fichier',
        noDownloadable: 'Aucun fichier téléchargeable dans la sélection',
        foldersSkipped: '{count} dossier(s) ignoré(s) — non téléchargeables',
        toast: {
            itemsLabel: '{count} éléments',
            buildingDetail: '{processed} / {total} fichier(s) compressé(s)',
            readyDetail: '{count} fichier(s) — {filename}',
        },
    },
    bulkMenu: {
        subheader: '{count} élément(s) sélectionné(s)',
        groupIntoFolder: 'Regrouper',
        groupSuccess: '{count} élément déplacé dans « {name} » | {count} éléments déplacés dans « {name} »',
        createCollection: 'Créer une collection',
        createCollectionSuccess: '{count} élément ajouté à « {name} » | {count} éléments ajoutés à « {name} »',
        createCollectionError: 'Échec de l\'ajout des éléments à la collection',
    },
    preview: {
        title: 'Aperçu',
        loadError: 'Impossible de charger l\'aperçu',
        notAvailable: 'Aperçu non disponible pour ce type de fichier',
        openDetails: 'Ouvrir les détails',
    },
    move: {
        title: 'Déplacer',
        subtitle: 'Sélectionnez le dossier de destination',
        selectDestination: 'Sélectionner le dossier de destination',
        itemCount: '{count} élément(s) à déplacer',
        moving: 'Éléments à déplacer',
        more: 'autres',
        searchPlaceholder: 'Rechercher un dossier...',
        destination: 'Destination',
        cannotMoveHere: 'Destination invalide',
        action: 'Déplacer',
        success: '{count} élément(s) déplacé(s)',
        successSingle: 'Élément déplacé avec succès',
        successMultiple: '{count} éléments déplacés avec succès',
        error: 'Erreur lors du déplacement',
        errorSameFolder: 'Impossible de déplacer un dossier dans lui-même',
        rootFolder: 'Racine',
    },
    createNew: {
        title: 'Nouveau',
        uploadFiles: 'Importer des fichiers',
        targetWorkspace: 'Espace de travail',
        targetWorkspaceHint: 'Sélectionnez l\'espace dans lequel créer',
        workspaceRequired: 'Sélectionnez un espace de travail',
        dropzoneTitle: 'Déposez vos fichiers ici',
        dropzoneSubtitle: 'ou cliquez pour parcourir',
        createSection: 'Créer',
        folder: 'Dossier',
        folderDescription: 'Organiser vos fichiers',
        collection: 'Collection',
        collectionDescription: 'Regrouper vos médias',
        note: 'Note',
        noteDescription: 'Documenter vos projets',
        thirdParty: 'Vidéo externe',
        thirdPartyDescription: 'YouTube, Vimeo, Dailymotion',
        importSection: 'Importer depuis',
        importFromService: 'Importer vos fichiers',
        uploadBanner: {
            uploading: '{count} envoi(s) en cours...',
            completed: 'Envois terminés',
            moreDetails: 'Plus de détails',
        },
    },
    importThirdParty: {
        title: 'Importer une vidéo externe',
        urlLabel: 'Lien de la vidéo ou code d’intégration',
        urlPlaceholder: 'Collez un lien YouTube, Vimeo ou Dailymotion, ou le code d’intégration d’un autre site...',
        urlHint: 'Les autres sites fonctionnent aussi : copiez le code d’intégration qu’ils vous donnent et collez-le ici.',
        submit: 'Importer',
        errorGeneric: "Impossible d'importer la vidéo. Vérifiez l'URL et réessayez.",
        preview: 'Aperçu',
        previewLoading: 'Récupération des informations...',
        previewError: "Impossible de récupérer les informations. Vérifiez l'URL et réessayez.",
        nameLabel: 'Nom',
        namePlaceholder: 'Saisissez un nom pour cet asset...',
        confirmImport: 'Importer cette vidéo',
        changeUrl: "Changer l'URL",
    },
    subtitles: {
        status: {
            processing: 'En cours...',
            processingPercent: 'En cours… {percent} %',
            failed: 'Erreur',
        },
        generation: {
            completed: 'Sous-titres générés avec succès',
            failed: 'Échec de la génération des sous-titres',
        },
        hero: {
            title: 'Sous-titres',
            description: 'Gérez les sous-titres de votre vidéo',
            features: {
                accuracy: '95%+ de précision',
                languages: '50+ langues',
                punctuation: 'Ponctuation auto',
            },
            import: 'Importer un fichier .srt/.vtt',
            pending: {
                title: 'Analyse audio requise',
                description: 'Ce média n\'a pas encore été analysé pour détecter les paroles. Lancez l\'analyse pour activer la génération automatique de sous-titres.',
                trigger: 'Analyser',
            },
            analyzing: {
                title: 'Analyse en cours',
                description: 'Nous analysons votre vidéo pour détecter les paroles. Cela peut prendre quelques minutes.',
            },
            failed: {
                title: 'Échec de l\'analyse',
                description: 'L\'analyse audio a échoué pour ce média. Vous pouvez relancer l\'analyse.',
                retry: 'Réessayer',
            },
            noSpeech: {
                title: 'Aucune parole détectée',
                description: 'Cette vidéo ne contient pas de paroles, les sous-titres automatiques ne peuvent pas être générés.',
            },
        },
        error: {
            title: 'Échec du chargement des sous-titres',
            description: 'Une erreur s\'est produite lors du chargement des sous-titres. Veuillez réessayer.',
            retry: 'Réessayer',
        },
        list: {
            title: 'Sous-titres',
            countNone: 'Aucun',
            countOne: '1 sous-titre',
            countMultiple: '{count} sous-titres',
            importAction: 'Importer .srt / .vtt',
            generateAction: 'Générer avec Scribe',
            columns: {
                track: 'Piste',
                atStart: 'Au démarrage',
                inMenu: 'Dans le menu CC',
                origin: 'Origine',
            },
            atStartLabel: 'Afficher {name} au démarrage',
            atStartYes: 'Oui',
            atStartSet: 'Afficher ces sous-titres dès le début de la vidéo',
            atStartClear: 'Ne plus les afficher au démarrage',
            atStartPlanned: 'Prévu',
            atStartHidden: 'Une piste masquée ne peut pas s’afficher au démarrage : proposez-la d’abord dans le menu CC',
            offered: 'Proposé',
            hidden: 'Masqué',
            inMenuLabel: 'Proposer {name} dans le menu CC',
            offeredWhenReady: 'Dès que prêt',
            origin: {
                imported: 'Importé',
                generated: 'Généré par Scribe',
                translated: 'Traduit par IA',
            },
            rule: 'Une seule piste peut s’afficher au démarrage. Une piste masquée ne peut pas l’être.',
            autoGeneratedHint: 'Mention « autogénéré » dans le lecteur',
            labelPlaceholder: 'Nom du sous-titre',
            actions: {
                edit: 'Modifier',
                download: 'Télécharger',
                delete: 'Supprimer',
                retry: 'Réessayer',
            },
        },
        viewer: {
            eyebrow: 'Ce que voit le spectateur',
            noTrack: 'Cette vidéo n’a pas encore de sous-titres.',
            noButton: 'Le bouton CC n’apparaît pas dans le lecteur tant qu’aucune piste n’est ajoutée.',
            startsWith: 'Les sous-titres {name} s’affichent dès le début de la vidéo.',
            willStartWith: 'Génération en cours : les sous-titres {name} s’afficheront dès le début de la vidéo quand ils seront prêts.',
            firstReadyWillStart: 'Génération en cours : les premiers sous-titres prêts s’afficheront dès le début de la vidéo.',
            startsWithNone: 'Aucun sous-titre ne s’affiche au démarrage.',
            scope: 'Sur les partages, la chaîne et les liens directs ; dans une intégration, seulement si son option « Afficher les sous-titres automatiquement » est activée.',
            menu: 'Le spectateur peut aussi choisir dans le menu {cc} du lecteur : {names}.',
            meanwhile: 'Rien ne change pour le spectateur d’ici là. Vous pouvez quitter cette page.',
            noMenu: 'Le bouton {cc} n’apparaît pas dans le lecteur : aucun sous-titre n’y est proposé.',
            soon: 'Sous-titres {name} bientôt ici',
            soonFirst: 'Sous-titres bientôt ici',
            clearDefault: 'Ne rien afficher au démarrage',
            hint: 'Réglez chaque piste dans la liste ci-dessous.',
            firstWillStart: 'Dès qu’ils seront prêts, les sous-titres s’afficheront au démarrage des partages, des intégrations, de la chaîne et des liens directs.',
            nowDefault: 'Sous-titres {name} prêts. Ils s’affichent désormais au démarrage des partages, des intégrations, de la chaîne et des liens directs.',
            undoDefault: 'Ne pas les afficher au démarrage',
        },
        start: {
            generate: {
                title: 'Générer avec Scribe',
                description: 'Transcription automatique de la vidéo, puis traduction dans d’autres langues si vous le souhaitez.',
                action: 'Générer les sous-titres',
            },
            firstIsDefault: 'Les premiers sous-titres prêts s’afficheront au démarrage des partages, des intégrations, de la chaîne et des liens directs. Vous pourrez changer ce réglage ensuite.',
            import: {
                title: 'Importer un fichier',
                description: 'Vous avez déjà vos sous-titres ? Importez un fichier .srt ou .vtt et choisissez sa langue.',
                action: 'Choisir un fichier',
            },
        },
        generateModal: {
            title: 'Générer des sous-titres',
            description: 'Scribe transcrira automatiquement votre vidéo avec l\'IA',
            language: 'Langue des sous-titres',
            duration: 'Durée de la vidéo',
            costPerMinute: 'Coût par minute',
            totalCost: 'Coût total',
            credits: 'crédits',
            cancel: 'Annuler',
            generate: 'Générer',
        },
        importModal: {
            title: 'Importer des sous-titres',
            description: 'Sélectionnez la langue du fichier de sous-titres que vous importez.',
            language: 'Langue des sous-titres',
            cancel: 'Annuler',
            import: 'Importer',
        },
    },
    chapters: {
        hero: {
            title: 'Chapitres',
            description: 'Ajoutez des chapitres pour aider les spectateurs à naviguer dans votre vidéo',
            add: 'Ajouter un chapitre',
            importClipboard: 'Importer depuis le presse-papiers',
        },
        banner: {
            title: 'Ajoutez des chapitres à votre vidéo',
            description: 'Aidez vos spectateurs à naviguer en marquant les moments clés. Ajoutez des chapitres manuellement ou importez une liste depuis votre presse-papiers.',
            pending: {
                title: 'Analyse audio requise',
                description: 'Ce média n\'a pas encore été analysé pour détecter les paroles. Lancez l\'analyse pour activer la génération de chapitres par IA.',
                trigger: 'Analyser',
            },
            analyzing: {
                title: 'Analyse en cours',
                description: 'Nous analysons votre média pour détecter les paroles. Cela peut prendre quelques minutes.',
            },
            failed: {
                title: 'Échec de l\'analyse',
                description: 'L\'analyse audio a échoué pour ce média. Vous pouvez relancer l\'analyse.',
                retry: 'Réessayer',
            },
            noSpeech: {
                title: 'Aucune parole détectée',
                description: 'Ce média ne contient pas de paroles, la génération automatique de chapitres n\'est pas disponible.',
            },
            ready: {
                title: 'Génération de chapitres par IA',
                description: 'Générez automatiquement des chapitres à partir de la transcription grâce à l\'IA.',
            },
            generate: 'Générer',
        },
        generateModal: {
            title: 'Générer des chapitres',
            generating: 'Génération des chapitres...',
            generatingDescription: 'L\'IA analyse la transcription pour identifier les chapitres.',
            preview: 'Chapitres générés',
            previewDescription: 'Vérifiez les chapitres ci-dessous avant de les importer.',
            replace: 'Remplacer tout',
            append: 'Ajouter aux existants',
            error: 'Échec de la génération',
            errorDescription: 'Une erreur est survenue lors de la génération des chapitres. Veuillez réessayer.',
            retry: 'Réessayer',
            count: '{count} chapitres générés',
        },
        importConfirm: {
            title: 'Importer des chapitres',
            message: '{count} chapitres trouvés dans le presse-papiers. Vous avez déjà des chapitres existants.',
            replace: 'Tout remplacer',
            append: 'Ajouter à la suite',
        },
        list: {
            title: 'Chapitres',
            countNone: 'Aucun',
            countOne: '1 chapitre',
            countMultiple: '{count} chapitres',
            emptyTitle: 'Aucun chapitre',
            emptyDescription: 'Ajoutez votre premier chapitre pour commencer',
            namePlaceholder: 'Nom du chapitre',
            importHint: 'Vous pouvez importer plusieurs chapitres en une fois. Préparez votre liste dans un éditeur de texte ou un tableur au format ci-dessous, copiez-la, puis cliquez sur « Importer depuis le presse-papiers ».',
            importFormat: 'Format attendu : un chapitre par ligne',
            importExample: '00:00:00 - Introduction\n00:02:30 - Premier sujet\n00:15:00 - Conclusion',
            actions: {
                delete: 'Supprimer',
            },
        },
        error: {
            title: 'Échec du chargement des chapitres',
            description: 'Une erreur s\'est produite lors du chargement des chapitres. Veuillez réessayer.',
            retry: 'Réessayer',
        },
        unsavedChanges: 'Vous avez des modifications non enregistrées',
        saveSuccess: 'Chapitres enregistrés avec succès',
        saveError: 'Échec de l\'enregistrement des chapitres',
    },
    interactivity: {
        title: 'Interactions',
        description: 'Affichez des appels à l\'action, des demandes d\'avis et plus encore directement dans le lecteur, à tout moment pendant la lecture.',
        workspaceDescription: 'Affichez des appels à l\'action, des demandes d\'avis et plus encore directement dans le lecteur vidéo. Les interactions définies ici sont automatiquement appliquées à tous les assets de cet espace.',
        organizationDescription: 'Affichez des appels à l\'action, des demandes d\'avis et plus encore directement dans le lecteur vidéo. Les interactions définies ici sont automatiquement appliquées à tous les assets de l\'organisation.',
        addInteraction: 'Ajouter',
        inheritedInfo: 'Les interactions héritées de l\'organisation ou de l\'espace sont également actives sur cet asset.',
        saved: 'Interaction créée',
        updated: 'Interaction mise à jour',
        deleted: 'Interaction supprimée',
        saveError: 'Erreur lors de la sauvegarde',
        recommendations: {
            description: 'Proposez d\'autres vidéos à la fin de celle-ci, dans le lecteur intégré et sur les pages de partage.',
            heading: 'Titre',
            headingPlaceholder: 'À voir ensuite',
            empty: {
                title: 'Aucune vidéo recommandée',
                description: 'Ajoutez jusqu\'à 8 vidéos à proposer lorsque celle-ci se termine.',
            },
            previewEmpty: 'Ajoutez des vidéos pour voir le bandeau de fin.',
            notReady: 'Pas encore prête',
            moveUp: 'Monter',
            moveDown: 'Descendre',
            remove: 'Retirer',
            unsavedChanges: 'Vous avez des modifications non enregistrées',
            saveSuccess: 'Recommandations enregistrées',
            saveError: 'Échec de l\'enregistrement des recommandations',
        },
        cards: {
            configure: 'Configurer',
            close: 'Fermer',
            ctaNone: 'Aucun CTA',
            ctaOff: 'Désactivés',
            ctaActive: '{n} CTA actif | {n} CTA actifs',
            inherited: '{n} hérité | {n} hérités',
            ctaSwitchHint: 'Ajoutez un CTA pour pouvoir l\'activer',
            ratingNone: 'Pas encore créé',
            ratingOff: 'Désactivé',
            ratingOn: 'Actif · {when}',
            recoNone: 'Aucune vidéo',
            recoCount: '{n} vidéo | {n} vidéos',
            toggledOn: 'Activé',
            toggledOff: 'Désactivé',
        },
        panel: {
            ctaTitle: 'Appels à l\'action',
            ctaOff: 'Les CTA de cette vidéo sont désactivés : aucun n\'est affiché aux spectateurs.',
            ratingOff: 'L\'avis est désactivé : il n\'est pas affiché aux spectateurs.',
            enable: 'Activer',
            addCta: 'Ajouter un CTA',
            newCta: 'Nouveau CTA',
            unsaved: 'Non enregistré',
            inactive: 'Désactivé',
            untitled: 'Sans titre',
            deleteCta: 'Supprimer ce CTA',
            emptyCta: {
                title: 'Aucun CTA sur cette vidéo',
                description: 'Ajoutez un bouton qui mène vos spectateurs où vous voulez, au moment que vous choisissez.',
            },
            inheritedFromWorkspace: 'Hérité de l\'espace',
            inheritedFromOrganization: 'Hérité de l\'organisation',
            rating: {
                // The player shows one rating per video, the narrowest scope's: these say which.
                replacesInherited: {
                    workspace: 'Cet avis remplace celui de l\'espace.',
                    organization: 'Cet avis remplace celui de l\'organisation.',
                },
                inheritedShown: {
                    workspace: 'L\'avis de l\'espace s\'affiche ici : en activer un le remplacera.',
                    organization: 'L\'avis de l\'organisation s\'affiche ici : en activer un le remplacera.',
                },
            },
            readOnlyWorkspace: 'Seule une personne qui gère cet espace peut modifier ses interactions.',
            readOnlyOrganization: 'Seule une personne qui gère les paramètres de l\'organisation peut modifier ses interactions.',
            editInWorkspace: 'Modifier dans l\'espace',
            overlapWarning: 'Au même endroit et au même moment que « {name} » : les deux se superposeront.',
            ctaInvalid: 'Ajoutez un message ou un bouton complet : son texte et son lien.',
            ratingInvalid: 'Renseignez la question.',
            unsavedChanges: 'Vous avez des modifications non enregistrées',
            saveSuccess: 'Modifications enregistrées',
            saveError: 'Échec de l\'enregistrement',
            discard: {
                title: 'Abandonner les modifications ?',
                message: 'Les modifications non enregistrées seront perdues.',
                confirm: 'Abandonner',
                cancel: 'Continuer l\'édition',
            },
        },
        timeline: {
            title: 'Sur la durée de la vidéo',
            onPause: '{n} à la pause | {n} à la pause',
        },
        types: {
            cta: 'Appel à l\'action',
            ctaDescription: 'Ajoutez un bouton cliquable sur votre vidéo',
            rating: 'Avis',
            ratingDescription: 'Recueillez les avis de vos spectateurs',
            recommendations: 'Recommandations',
        },
        triggers: {
            atMoment: 'À un moment',
            atShare: 'À un pourcentage',
            atTimecode: 'À {time}',
            atPercentValue: 'À {percent} %',
            atTime: 'À',
            atPercent: 'À',
            videoStart: 'Début de la vidéo',
            videoEnd: 'Fin de la vidéo',
            onPause: 'Lors d\'une pause',
        },
        positions: {
            center: 'Centre',
            topLeft: 'Haut gauche',
            topCenter: 'Haut centre',
            topRight: 'Haut droite',
            bottomLeft: 'Bas gauche',
            bottomCenter: 'Bas centre',
            bottomRight: 'Bas droite',
            fullscreen: 'Plein écran',
        },
        animations: {
            fade: 'Fondu',
            slideUp: 'Glissement vers le haut',
            slideDown: 'Glissement vers le bas',
            scale: 'Échelle',
            none: 'Aucune',
        },
        form: {
            when: 'Quand',
            where: 'Où',
            moreOptions: 'Plus d\'options',
            triggerTimecode: 'Moment (min:s)',
            ofDuration: 'sur {duration}',
            back: 'Retour',
            captions: {
                start: 'S\'affiche dès le début de la lecture.',
                time: 'S\'affiche à {time}.',
                percent: 'S\'affiche à {percent} % de la vidéo.',
                end: 'S\'affiche à la fin de la vidéo.',
                pause: 'S\'affiche quand le spectateur met la vidéo en pause.',
            },
            createTitle: 'Nouvelle interaction',
            editTitle: 'Modifier l\'interaction',
            trigger: 'Déclencheur',
            triggerTime: 'Temps (secondes)',
            triggerPercent: 'Pourcentage visionné',
            content: 'Contenu',
            ctaText: 'Texte',
            ctaButtonText: 'Texte du bouton',
            ctaTextDefault: 'Découvrez la suite sur notre site.',
            ctaButtonTextOptional: 'Texte du bouton (facultatif)',
            ctaUrlOptional: 'Lien du bouton (facultatif)',
            ctaButtonLabelMissing: 'Donnez un texte au bouton, ou videz son lien pour n\'afficher que le message.',
            ctaButtonLinkMissing: 'Ajoutez le lien du bouton, ou videz son texte pour n\'afficher que le message.',
            ctaTextOnly: 'Sans bouton, le CTA affiche seulement son message.',
            ctaButtonTextDefault: 'En savoir plus',
            ctaUrl: 'URL du bouton',
            ctaButtonVariant: 'Style du bouton',
            ctaButtonVariantFilled: 'Plein',
            ctaButtonVariantTonal: 'Tonal',
            ctaButtonVariantOutlined: 'Contour',
            ctaButtonVariantText: 'Lien texte',
            ctaButtonColor: 'Couleur du bouton',
            ratingQuestion: 'Question',
            ratingQuestionDefault: 'Comment évaluez-vous cette vidéo ?',
            enableComment: 'Permettre un commentaire texte',
            commentPlaceholder: 'Ajouter un commentaire...',
            preview: 'Aperçu',
            position: 'Position',
            display: 'Affichage',
            animation: 'Animation',
            autoHide: 'Masquer après (secondes)',
            autoHidePlaceholder: 'Jamais',
            dismissible: 'Peut être fermé',
            showOnce: 'Afficher une seule fois par session',
            pausesVideo: 'Mettre en pause la vidéo à l\'affichage',
            showMarker: 'Afficher un marqueur sur la barre de lecture',
            previewTrigger: 'Prévisualiser',
            required: 'Ce champ est requis',
            recommendedVideos: 'Vidéos recommandées',
            addVideos: 'Ajouter des vidéos',
            maxVideos: 'Maximum {n} vidéos',
            recommendationsInfo: 'Les recommandations s\'affichent en plein écran à la fin de la vidéo.',
            cancel: 'Annuler',
            create: 'Créer',
            save: 'Enregistrer',
        },
        empty: {
            title: 'Aucune interaction',
            description: 'Ajoutez des interactions comme des appels à l\'action ou des demandes d\'avis sur vos intégrations.',
            workspaceDescription: 'Ajoutez des appels à l\'action, des demandes d\'avis et plus encore à afficher dans le lecteur vidéo pour tous les assets de cet espace.',
            organizationDescription: 'Ajoutez des appels à l\'action, des demandes d\'avis et plus encore à afficher dans le lecteur vidéo pour tous les assets de l\'organisation.',
        },
        error: {
            title: 'Échec du chargement des interactions',
            description: 'Une erreur est survenue lors du chargement des interactions.',
            retry: 'Réessayer',
        },
        deleteConfirm: {
            title: 'Supprimer l\'interaction',
            message: 'Êtes-vous sûr de vouloir supprimer cette interaction ? Cette action est irréversible.',
            confirm: 'Supprimer',
        },
    },
    aiWriting: {
        title: 'Rédaction IA',
        subtitle: 'Générez du contenu à partir de votre transcription grâce à l\'IA',
        types: {
            titles: 'Titres',
            titlesDesc: 'Générer des titres percutants pour votre contenu',
            description: 'Description',
            descriptionDesc: 'Générer de courtes descriptions (2-3 phrases)',
            summary: 'Résumé',
            summaryDesc: 'Générer des résumés détaillés (4-6 phrases)',
            seoKeywords: 'Mots-clés SEO',
            seoKeywordsDesc: 'Générer des listes de mots-clés SEO pertinents',
        },
        form: {
            language: 'Langue',
            languageSpoken: 'Langue de la vidéo',
            tone: 'Ton',
            context: 'Contexte additionnel',
            contextPlaceholder: 'Ajoutez des instructions ou du contexte pour guider l\'IA...',
            generate: 'Générer',
        },
        tones: {
            professional: 'Professionnel',
            casual: 'Décontracté',
            formal: 'Formel',
            creative: 'Créatif',
        },
        results: {
            title: 'Suggestions',
            emptyTitle: 'Aucune suggestion',
            emptyDescription: 'Configurez vos options et cliquez sur Générer pour obtenir des suggestions par IA.',
            generating: 'Génération des suggestions...',
            generatingDescription: 'L\'IA analyse la transcription pour générer du contenu.',
            error: 'Échec de la génération',
            errorDescription: 'Une erreur est survenue lors de la génération du contenu. Veuillez réessayer.',
            retry: 'Réessayer',
            regenerate: 'Regénérer',
            copy: 'Copier',
            copied: 'Copié dans le presse-papiers',
            apply: 'Appliquer',
            applied: 'Appliqué',
        },
        applied: 'Contenu appliqué avec succès',
        tagsAdded: '{count} mot(s)-clé(s) ajouté(s) comme tags',
        tagsAddError: '{count} mot(s)-clé(s) n\'ont pas pu être ajoutés comme tags',
        tagsRestricted: '{count} mot(s)-clé(s) ignoré(s) : seuls les tags existants peuvent être ajoutés',
        unavailable: 'Rédaction IA indisponible',
        unavailableDescription: 'Cette fonctionnalité nécessite une vidéo ou un audio avec des paroles détectées. Veuillez d\'abord générer les sous-titres.',
        noSpeechDescription: 'Aucune parole n\'a été détectée dans ce média : il n\'y a pas de transcription à partir de laquelle rédiger.',
    },
    aiWritingV2: {
        generateAll: 'Tout générer',
        addContext: 'Ajouter du contexte',
        summaryHint: 'Le résumé est donné à titre indicatif et ne peut pas être appliqué directement à un champ.',
    },
    files: {
        title: 'Fichiers & Versions',
        description: 'Gérez les fichiers sources et l\'historique des versions',
        download: 'Télécharger',
        sourceDownloadUrl: 'Lien permanent du fichier source',
        sourceDownloadUrlHint:
            'Les PDF et les images s\'affichent dans le navigateur, les autres fichiers se téléchargent. Ajoutez ?attachment=true pour forcer le téléchargement.',
        copyLink: 'Copier le lien',
        linkCopied: 'Lien copié !',
        copyFailed: 'Échec de la copie',
        versionHistory: 'Historique des versions',
        current: 'Actuelle',
        deleted: 'Supprimée',
        purged: 'Supprimée définitivement',
        droppedRetention: 'Une version supprimée reste restaurable et facturée pendant 30 jours, puis elle est supprimée définitivement.',
        countNone: 'Aucune version',
        countOne: '1 version',
        countMultiple: '{count} versions',
        emptyTitle: 'Aucune version disponible',
        emptyDescription: 'Téléversez un fichier pour créer la première version',
        error: {
            title: 'Échec du chargement des versions',
            description: 'Une erreur s\'est produite lors du chargement de l\'historique des versions. Veuillez réessayer.',
            retry: 'Réessayer',
        },
        actions: {
            revert: 'Revenir à cette version',
            delete: 'Supprimer cette version',
            purge: 'Supprimer définitivement',
        },
        deleteConfirm: {
            title: 'Supprimer la version',
            message: 'La version {version} — son fichier source et ses renditions — part à la corbeille. Vous pourrez la restaurer d\'ici pendant 30 jours ; elle reste facturée jusqu\'à sa suppression définitive, automatique au bout de 30 jours.',
            confirm: 'Mettre à la corbeille',
            cancel: 'Annuler',
        },
        actionsRestore: 'Restaurer cette version',
        restoreSuccess: 'Version {version} restaurée',
        restoreError: 'Échec de la restauration de la version',
        purgeConfirm: {
            title: 'Supprimer définitivement la version',
            message: 'La version {version} — son fichier source et ses renditions — sera supprimée définitivement et cessera d\'être facturée. Cette action est irréversible : la version ne pourra plus être restaurée.',
            confirm: 'Supprimer définitivement',
        },
        purgeSuccess: 'Version {version} supprimée définitivement',
        purgeError: 'Échec de la suppression définitive de la version',
        purgeLocked: 'Ce média a été validé dans le pool : seul un modérateur du pool peut supprimer définitivement cette version.',
        revertConfirm: {
            title: 'Revenir à la version',
            message: 'Êtes-vous sûr de vouloir revenir à la version {version} ? Elle deviendra la version actuelle.',
            confirm: 'Revenir',
            cancel: 'Annuler',
        },
        deleteSuccess: 'Version {version} mise à la corbeille',
        deleteError: 'Échec de la suppression de la version',
        revertSuccess: 'Retour à la version {version}',
        revertError: 'Échec du retour à la version',
        replace: {
            button: 'Remplacer le fichier',
            confirmTitle: 'Remplacer le fichier',
            confirmMessage: 'Cela créera une nouvelle version. La version actuelle sera conservée dans l\'historique.',
            confirmButton: 'Remplacer',
            error: 'Impossible de démarrer l\'envoi. Veuillez réessayer.',
        },
        processing: {
            title: 'Traitement en cours',
            pending: 'En attente...',
            uploading: 'Téléversement...',
            fetchingSource: 'Téléchargement depuis le lien...',
            extractingMetadata: 'Extraction des métadonnées...',
            extractingText: 'Lecture du texte...',
            generatingThumbnails: 'Génération des aperçus...',
            drawingWaveform: 'Tracé de la forme d\'onde...',
            buildingFilmstrip: 'Création de la bande d\'aperçus...',
            encoding: 'Encodage pour le streaming...',
            completed: 'Terminé',
            failed: 'Le traitement a échoué',
            failedTitle: 'Erreur de traitement',
            failedDescription: 'Une erreur s\'est produite lors du traitement du fichier. Vous pouvez envoyer un nouveau fichier ou revenir à la version précédente.',
            interruptedTitle: 'Import interrompu',
            interruptedDescription: 'Le fichier n\'est jamais arrivé : son envoi s\'est arrêté avant la fin. Envoyez-le à nouveau, le média garde son titre, son dossier et ses tags.',
            retryUpload: 'Envoyer un nouveau fichier',
            revertButton: 'Revenir à la v{version}',
        },
        relationships: {
            title: 'Fichiers liés',
            countNone: 'Aucun',
            countOne: '1 relation',
            countMultiple: '{count} relations',
            emptyTitle: 'Aucun fichier lié',
            emptyDescription: 'Liez d\'autres fichiers pour créer des relations',
            add: 'Ajouter une relation',
            types: {
                RELATED: 'Lié',
                DERIVED_FROM: 'Dérivé de',
                VERSION_OF: 'Version de',
                PART_OF: 'Partie de',
                DUPLICATE_OF: 'Doublon de',
                ALTERNATIVE_TO: 'Alternative à',
                REFERENCES: 'Référence',
                REFERENCED_BY: 'Référencé par',
                SUBTITLE_FOR: 'Sous-titre pour',
            },
            public: 'Public',
            private: 'Privé',
            publicTooltip: 'Lorsque public, ce fichier est proposé au téléchargement sur la page de partage et dans le player de cet asset',
            inLibrary: 'Bibliothèque',
            linkedOnly: 'Fichier lié',
            updateError: 'Échec de la mise à jour de la relation',
            deleteConfirm: {
                title: 'Supprimer la relation',
                message: 'Êtes-vous sûr de vouloir supprimer cette relation avec « {name} » ?',
                confirm: 'Supprimer',
            },
            addModal: {
                title: 'Ajouter une relation',
                selectAsset: 'Sélectionner un asset',
                selectAssetDescription: 'Choisissez un asset à lier avec celui-ci',
                typeLabel: 'Type de relation',
            },
            wizard: {
                title: 'Ajouter une relation',
                source: {
                    subtitle: 'Choisissez comment ajouter l\'asset lié',
                    upload: {
                        title: 'Téléverser un fichier',
                        description: 'Téléversez un nouveau fichier à lier avec cet asset',
                    },
                    library: {
                        title: 'Sélectionner depuis la bibliothèque',
                        description: 'Choisissez un asset existant de votre bibliothèque',
                    },
                },
                file: {
                    title: 'Fichier',
                    uploadLabel: 'Déposez un fichier ou cliquez pour parcourir',
                    selectedFile: 'Fichier sélectionné',
                    selectedAsset: 'Asset sélectionné',
                    changeFile: 'Modifier',
                    selectAsset: 'Sélectionner un asset',
                    selectAssets: 'Sélectionner des assets',
                    addMore: 'Ajouter d\'autres',
                    uploadNotice: 'Les fichiers seront liés directement à cet asset et ne seront pas visibles dans votre bibliothèque.',
                    makePublic: 'Rendre disponible au téléchargement sur la page de partage et dans le player',
                    makePublicHint: 'Modifiable ensuite depuis la liste des fichiers liés.',
                },
                validation: {
                    selectSource: 'Veuillez sélectionner un type de source',
                    selectFile: 'Veuillez sélectionner ou téléverser un fichier',
                },
            },
            uploadStarted: 'Téléversement lancé — la relation sera créée automatiquement',
            addSuccess: 'Relation ajoutée',
            addError: 'Échec de l\'ajout de la relation',
            deleteSuccess: 'Relation supprimée',
            deleteError: 'Échec de la suppression de la relation',
            lockedOther: 'Ce lien touche un asset validé dans le fonds commun : seul un modérateur du fonds commun peut le créer ou le retirer.',
        },
        audioTracks: {
            title: 'Bandes son',
            countNone: 'Son d\'origine uniquement',
            countOne: '1 piste ajoutée',
            countMultiple: '{count} pistes ajoutées',
            intro: 'Proposez la même vidéo dans une autre langue ou dans une version adaptée (dialogues renforcés, sans musique…). L\'image reste la même : le spectateur choisit le son dans le menu Paramètres › Audio du lecteur.',
            add: 'Ajouter une bande son',
            loadError: 'Impossible de charger les bandes son.',
            empty: {
                title: 'Rendez cette vidéo accessible dans d\'autres langues',
                description: 'Ajoutez un doublage ou une version adaptée : l\'image ne change pas, le spectateur choisit le son dans le lecteur.',
                steps: {
                    language: { title: 'Choisissez la langue', text: 'et le nom affiché aux spectateurs' },
                    file: { title: 'Importez le fichier audio', text: 'de la même durée que la vidéo' },
                    player: { title: 'Elle arrive dans le lecteur', text: 'une fois préparée' },
                },
            },
            original: {
                name: 'Son d\'origine',
                description: 'Le son du fichier vidéo, toujours proposé dans le lecteur',
            },
            footnote: 'MP3, WAV, AAC, M4A ou FLAC · 500 Mo maximum · la piste doit avoir la même durée que la vidéo.',
            dialog: {
                title: 'Ajouter une bande son',
                intro: 'Une bande son remplace le son de la vidéo sans toucher à l\'image : un doublage dans une autre langue, une version avec dialogues renforcés, une version sans musique… Le spectateur passe de l\'une à l\'autre depuis le lecteur.',
                checklist: {
                    duration: 'Même durée que la vidéo, calée sur la même image de départ.',
                    mix: 'Le mixage complet (voix, musique et effets), pas les voix seules.',
                    formats: 'MP3, WAV, AAC, M4A ou FLAC, 500 Mo maximum.',
                },
                language: 'Langue',
                languageHint: 'Choisissez ou tapez un code (ex. fr, en, es)',
                languageInvalid: '« {value} » n\'est pas un code de langue. Un code s\'écrit en deux ou trois lettres, éventuellement suivies d\'une région : fr, en, pt-BR…',
                name: 'Nom dans le lecteur',
                nameHint: 'Ce que le spectateur voit dans le menu Audio',
                hearingImpaired: 'Version sourds et malentendants',
                hearingImpairedHint: 'Dialogues renforcés : le lecteur la propose avec son bouton dédié.',
                defaultLater: 'Pour que le lecteur démarre sur cette piste, choisissez « Définir par défaut » dans la liste une fois qu\'elle y est disponible.',
                drop: 'Glissez un fichier audio ici ou cliquez pour parcourir',
                formats: 'MP3, WAV, AAC, M4A, FLAC · 500 Mo maximum',
                change: 'Changer',
                notAudio: 'Ce fichier n\'est pas un fichier audio.',
                tooLarge: 'Ce fichier dépasse 500 Mo.',
                durationMatches: 'Même durée que la vidéo',
                durationLonger: 'Cette piste dure {track}, la vidéo {video} : elle sera coupée à la fin de la vidéo.',
                durationShorter: 'Cette piste dure {track}, la vidéo {video} : elle sera complétée par du silence.',
                submit: 'Importer la piste',
            },
            defaultBadge: 'Par défaut',
            defaultPendingBadge: 'Par défaut une fois disponible',
            hearingImpaired: 'Sourds et malentendants',
            uploaded: 'Ajoutée',
            embedded: 'Fichier d\'origine',
            mono: 'Mono',
            channelsN: '{n} canaux',
            trackIndex: 'Piste {index}',
            unknownTrack: 'Piste',
            addedOn: 'ajoutée le {date}',
            playback: {
                ready: 'Disponible dans le lecteur',
                preparing: 'En préparation pour le lecteur. Cela peut prendre un moment ; vous pouvez quitter la page.',
                waiting: 'Prête : proposée dans le lecteur dès que la vidéo elle-même sera encodée.',
                failed: 'La préparation a échoué. Supprimez la piste et importez-la à nouveau.',
                unavailable: 'Pas encore proposée dans le lecteur. Supprimez la piste et importez-la à nouveau.',
                // A language of the video's own file: it has no file to import again.
                source: {
                    failed: 'La préparation de cette langue du fichier vidéo a échoué. Pour la proposer quand même, importez-la comme bande son séparée : un fichier audio de la même durée que la vidéo.',
                    unavailable: 'Cette langue du fichier vidéo n\'est pas proposée dans le lecteur. Pour la proposer, importez-la comme bande son séparée : un fichier audio de la même durée que la vidéo.',
                },
            },
            leave: {
                title: 'Envoi en cours',
                message: 'Une bande son est en train d\'être envoyée. Si vous quittez cette page, l\'envoi sera annulé et le fichier perdu.',
                confirm: 'Quitter et annuler l\'envoi',
                stay: 'Rester sur la page',
            },
            uploadProgress: 'Envoi {percent} % · {loaded} sur {total}. Gardez cet onglet ouvert.',
            uploadProgressEta: 'Envoi {percent} % · {loaded} sur {total} · environ {eta} restantes. Gardez cet onglet ouvert.',
            uploadFinishing: 'Envoi terminé, enregistrement…',
            etaSeconds: '{n} s',
            etaMinutes: '{n} min',
            uploadFailed: 'L\'envoi a échoué : {reason}',
            uploadFailure: {
                tooLarge: 'le fichier dépasse 500 Mo.',
                notAudio: 'ce fichier n\'est pas reconnu comme un fichier audio.',
                refused: 'le serveur a refusé le fichier ou sa description. Vérifiez qu\'il s\'agit d\'un fichier audio et que la langue est un code de langue.',
                network: 'la connexion a été interrompue. Vérifiez-la, puis réessayez.',
                other: 'le serveur n\'a pas pu l\'enregistrer. Réessayez dans un instant.',
            },
            dismiss: 'Retirer',
            setAsDefault: 'Définir par défaut',
            alreadyDefault: 'Piste par défaut',
            cannotSetDefaultUntilReady: 'Possible une fois la piste disponible dans le lecteur',
            editTooltip: 'Modifier le nom et la langue',
            editTitle: 'Modifier la bande son',
            download: 'Télécharger',
            delete: 'Supprimer',
            uploadSuccess: 'Bande son envoyée, préparation pour le lecteur en cours',
            uploadError: 'Échec de l\'envoi de la bande son',
            downloadError: 'Échec du téléchargement',
            updateSuccess: 'Bande son mise à jour',
            updateError: 'Échec de la mise à jour',
            deleteConfirm: 'Supprimer « {name} » de cette vidéo ?',
            deleteEmbeddedConfirm: 'Retirer « {name} » du lecteur ? Cette langue vient du fichier vidéo : une fois retirée, elle ne pourra pas être rétablie — seule une bande son importée séparément pourra la remplacer. Le fichier vidéo lui-même n\'est pas modifié.',
            deleteConfirmButton: 'Supprimer',
            deleteSuccess: 'Bande son supprimée',
            deleteError: 'Échec de la suppression',
        },
        collection: {
            mode: {
                description: 'Choisissez comment les éléments sont ajoutés à cette collection',
                onboarding: {
                    title: 'Comment souhaitez-vous construire cette collection ?',
                    description: 'Choisissez un mode pour déterminer comment les éléments sont ajoutés. Vous pourrez changer à tout moment.',
                },
                curated: {
                    title: 'Manuel',
                    label: 'Manuel',
                    description: 'Sélectionnez et ordonnez les éléments manuellement',
                    cardDescription: 'Choisissez chaque élément et organisez-les exactement comme vous le souhaitez.',
                    features: {
                        pick: 'Choisissez depuis votre bibliothèque',
                        order: 'Glissez-déposez pour réordonner',
                        control: 'Contrôle total sur votre contenu',
                    },
                },
                smart: {
                    title: 'Intelligent',
                    label: 'Intelligent',
                    description: 'Remplissage automatique basé sur des règles',
                    cardDescription: 'Définissez des règles et laissez la collection se remplir automatiquement.',
                    features: {
                        rules: 'Filtrez par type, tags, et plus',
                        auto: 'Se met à jour avec les nouveaux contenus',
                        time: 'Idéal pour les grandes collections évolutives',
                    },
                },
                change: 'Changer de mode',
                switchTitle: 'Changer de mode',
                switchToSmartWarning: 'Le passage en mode intelligent remplacera vos éléments ajoutés manuellement par des éléments sélectionnés automatiquement. Continuer ?',
                switchToCuratedConfirm: 'Voulez-vous conserver les éléments actuels lors du passage en mode manuel ?',
                changed: 'Mode de collection modifié',
                changeFailed: 'Échec du changement de mode',
            },
            contents: {
                hero: {
                    title: 'Contenu',
                    description: 'Gérez les éléments de cette collection',
                },
                error: {
                    title: 'Échec du chargement du contenu',
                    description: 'Un problème est survenu lors du chargement du contenu de la collection.',
                    retry: 'Réessayer',
                },
                title: 'Éléments',
                itemCount: {
                    zero: 'Aucun élément',
                    one: '1 élément',
                    other: '{count} éléments',
                },
                addItems: 'Ajouter des éléments',
                selectItems: 'Sélectionner les éléments à ajouter',
                addFirstItem: 'Ajouter le premier élément',
                emptyTitle: 'Aucun élément',
                emptyDescription: 'Ajoutez des éléments pour commencer à construire votre collection',
                noNewItems: 'Tous les éléments sélectionnés sont déjà dans la collection',
                itemsAdded: 'Éléments ajoutés à la collection',
                addFailed: 'Échec de l\'ajout des éléments',
                itemRemoved: 'Élément supprimé',
                removeFailed: 'Échec de la suppression de l\'élément',
                reorderFailed: 'Échec du réordonnancement des éléments',
                orderByChanged: 'Tri mis à jour',
                orderByChangeFailed: 'Échec de la mise à jour du tri',
            },
            orderBy: {
                position: 'Manuel (glisser-déposer)',
                nameAsc: 'Nom (A-Z)',
                nameDesc: 'Nom (Z-A)',
                createdAsc: 'Création (plus anciens)',
                createdDesc: 'Création (plus récents)',
                durationAsc: 'Durée (plus courts)',
                durationDesc: 'Durée (plus longs)',
            },
            smartRules: {
                maxItems: 'Nombre maximum d\'éléments',
                assetTypes: 'Types de fichiers',
                assetTypesHint: 'Laissez vide pour inclure tous les types',
                types: { video: 'Vidéo', image: 'Image', audio: 'Audio', document: 'Document' },
                includeTags: 'Inclure les tags',
                excludeTags: 'Exclure les tags',
                selectTags: 'Sélectionner des tags...',
                matchAll: 'Tous',
                matchAny: 'Au moins un',
                orderBy: {
                    title: 'Ordre de tri',
                    newestFirst: 'Plus récents en premier',
                    oldestFirst: 'Plus anciens en premier',
                    nameAsc: 'Nom (A-Z)',
                    nameDesc: 'Nom (Z-A)',
                    longestFirst: 'Plus longs en premier',
                    shortestFirst: 'Plus courts en premier',
                },
                preview: 'Aperçu',
                apply: 'Appliquer les règles',
                updated: 'Règles mises à jour',
                updateFailed: 'Échec de la mise à jour des règles',
                previewFailed: 'Échec de l\'aperçu des règles',
            },
            preview: {
                title: 'Aperçu',
                noItems: 'Aucun élément',
                itemCount: {
                    one: '1 élément',
                    other: '{count} éléments',
                },
                emptyHint: 'Les éléments apparaîtront ici',
            },
        },
    },
    list: {
        name: 'Nom',
        type: 'Type',
        duration: 'Durée',
        size: 'Taille',
        date: 'Date',
        workspace: 'Espace',
    },
    fileSelector: {
        selectFile: 'Sélectionner un fichier',
        selectFiles: 'Sélectionner des fichiers',
        search: 'Rechercher...',
        searchWorkspaces: 'Rechercher des espaces...',
        searchInFolder: 'Rechercher dans ce dossier...',
        allWorkspaces: 'Tous les espaces',
        files: 'fichiers',
        noWorkspacesFound: 'Aucun espace trouvé',
        error: 'Erreur lors du chargement des fichiers',
        empty: 'Aucun fichier trouvé',
        noResults: 'Aucun fichier ne correspond à votre recherche',
        selectedSingular: 'sélectionné',
        selectedPlural: 'sélectionnés',
        sources: 'Sources',
        quickAccess: 'Accès rapide',
        itemSelected: 'élément sélectionné',
        itemsSelected: 'éléments sélectionnés',
        clearSelection: 'Effacer',
        confirmSelection: 'Confirmer la sélection',
        maxSelectionHint: 'Sélectionnez jusqu\'à {max} fichiers',
        multipleHint: 'Cliquez sur les fichiers pour les sélectionner',
        clearSearch: 'Effacer la recherche',
        emptyTitle: 'Aucun fichier ici',
        emptyDescription: 'Ce dossier est vide. Naviguez vers un autre dossier ou espace.',
        noResultsTitle: 'Aucun résultat',
        noResultsDescription: 'Aucun fichier ne correspond à vos critères de recherche.',
        speechOnlyHint: 'Seuls les contenus contenant de la voix sont affichés.',
        errorTitle: 'Une erreur s\'est produite',
        errorDescription: 'Impossible de charger vos médias. C\'est peut-être temporaire — veuillez réessayer.',
        retry: 'Réessayer',
        workspacesError: 'Impossible de charger les espaces',
        emptyLibraryTitle: 'Votre médiathèque est vide',
        emptyLibraryDescription: 'Importez d\'abord des fichiers dans Mediasbox. Vos médias apparaîtront ici pour que vous puissiez les ajouter.',
        items: 'éléments',
        activeFilters: 'Filtré',
        alreadyAdded: 'Déjà ajouté',
        filterBy: 'Filtrer par :',
        flatView: 'Tous les fichiers',
        flatViewTooltip: 'Afficher tous les fichiers sans dossiers',
        selectAll: 'Tout sélectionner',
        deselectAll: 'Tout désélectionner',
        addFolderContents: 'Ajouter le contenu du dossier',
        addFolderWithSubfolders: 'Ajouter tout le contenu (sous-dossiers inclus)',
        folderAdded: '{count} éléments ajoutés depuis le dossier',
        folderAllAlreadyAdded: 'Tous les éléments de ce dossier sont déjà dans la collection',
        folderAllAlreadySelected: 'Tous les éléments de ce dossier sont déjà sélectionnés',
        filters: {
            hasSpeech: 'Avec parole',
        },
    },
    types: {
        video: 'Vidéo',
        audio: 'Audio',
        image: 'Image',
        document: 'Document',
        folder: 'Dossier',
        collection: 'Collection',
        third_party: 'Vidéo externe',
    },
    folderBrowser: {
        emptyFolder: 'Ce dossier est vide',
        navigateHint: 'Double-cliquez pour entrer dans le dossier',
    },
    share: {
        action: 'Partager',
        existingError: "Les liens déjà créés pour ce fichier n'ont pas pu être lus.",
        title: 'Partager des fichiers',
        subtitle: 'Créer un lien public pour partager vos fichiers',
        filesColumn: 'Fichiers',
        createLink: 'Créer le lien de partage',
        creating: 'Création du lien…',
        regenerate: 'Régénérer un nouveau lien',
        steps: {
            preview: 'Sélection',
            options: 'Options',
            result: 'Lien de partage',
        },
        validation: {
            noAssets: 'Aucun fichier sélectionné',
        },
        preview: {
            title: 'Éléments à partager',
            itemCount: '{count} élément | {count} éléments',
            selectedCount: '{count} élément sélectionné | {count} éléments sélectionnés',
            types: {
                video: 'Vidéo',
                image: 'Image',
                audio: 'Audio',
                folder: 'Dossier',
                other: 'Fichier',
            },
            folderNotice: 'Les dossiers partagés incluront tout leur contenu.',
        },
        options: {
            basicInfo: 'Informations de base',
            name: 'Nom du lien',
            namePlaceholder: 'ex. Revue client',
            defaultName: 'Partage du {date}',
            nameRequired: 'Le nom est requis',
            description: 'Description',
            descriptionPlaceholder: 'Notes optionnelles pour ce partage...',
            permissions: 'Permissions',
            allowDownload: 'Autoriser les téléchargements',
            allowDownloadHint: 'Les destinataires peuvent télécharger les fichiers originaux',
            security: 'Sécurité',
            passwordProtection: 'Protection par mot de passe',
            passwordHint: 'Exiger un mot de passe pour accéder à ce partage',
            passwordEnable: 'Exiger un mot de passe',
            password: 'Mot de passe',
            passwordPlaceholder: 'Entrer un mot de passe',
            limits: 'Limites',
            expiration: 'Expiration',
            expirationHint: 'Par défaut le lien expire dans {count} jour — désactivez ou modifiez la date pour un lien plus long | Par défaut le lien expire dans {count} jours — désactivez ou modifiez la date pour un lien plus long',
            expiresInDays: 'Expire dans {count} jour | Expire dans {count} jours',
            expiredBadge: 'Expiré',
            expirationNone: 'N\'expire jamais',
            expirationCustom: 'Expire le',
            expirationDate: 'Date d\'expiration',
            maxViews: 'Limite d\'ouvertures',
            maxViewsHint: 'Limiter le nombre de fois que ce partage peut être ouvert',
            maxViewsUnlimited: 'Illimité',
            maxViewsCustom: 'Limité à',
            maxViewsLabel: 'Nombre maximum d\'ouvertures',
            maxViewsSuffix: 'ouvertures',
            display: 'Affichage',
            hideAssetInfo: 'Masquer les détails',
            hideAssetInfoHint: 'Masquer le titre, la description et la durée sur la page publique',
            hideDate: 'Masquer la date',
            hideDateHint: 'Masquer la date de création sur la page publique',
            status: 'Statut',
        },
        existingLink: {
            title: 'Vous modifiez un lien déjà partagé',
            subtitle: 'Toute modification sera immédiatement visible par les personnes ayant ce lien.',
        },
        result: {
            copy: 'Copier',
            copied: 'Copié !',
            historyTitle: 'Mes liens de partage',
            historySubtitle: 'Voir et gérer tous vos liens créés précédemment',
            historyTitleAsset: 'Liens de partage de ce contenu',
            historySubtitleAsset: 'Voir et gérer tous les liens créés pour ce contenu',
        },
        email: {
            tabLink: 'Lien de partage',
            tabEmail: 'Envoyer par e-mail',
            new: 'Nouveau',
            recipients: 'Destinataires',
            recipientsPlaceholder: 'Ajouter un e-mail…',
            subject: 'Objet',
            subjectDefault: 'Des fichiers partagés avec vous — {name}',
            message: 'Message',
            messagePlaceholder: 'Ajouter un mot personnel (facultatif)…',
            filesHeading: 'Fichiers',
            optionsLabel: 'Options de l’envoi',
            openLimit: 'Limite d’ouvertures par destinataire',
            openLimitHint: 'Chaque destinataire reçoit un lien personnel, ouvrable un nombre limité de fois',
            replyToHint: 'Chaque destinataire reçoit un lien personnel — les réponses arrivent sur votre adresse, avec suivi des ouvertures et clics par personne.',
            send: 'Envoyer à {count} destinataire | Envoyer à {count} destinataires',
            sendEmpty: 'Envoyer',
            sending: 'Envoi…',
            success: 'E-mail envoyé à {count} destinataire | E-mail envoyé à {count} destinataires',
            error: 'Échec de l’envoi de l’e-mail',
            tooMany: 'Vous pouvez envoyer à {max} destinataires au maximum',
            invalidEmails: 'Certaines adresses ne sont pas valides',
        },
        error: 'Échec de la création du lien de partage',
    },
    moderation: {
        title: 'Modération',
        pending: 'En attente',
        approved: 'Approuvé',
        rejected: 'Rejeté',
        exempted: 'Exempté',
        filterAll: 'Tous',
        selected: 'sélectionnés',
        approve: 'Approuver',
        reject: 'Rejeter',
        resetPending: 'Remettre en attente',
        approveSelected: 'Approuver la sélection',
        rejectSelected: 'Rejeter la sélection',
        rejectTitle: 'Rejeter les assets',
        rejectReason: 'Raison du rejet',
        rejectReasonPlaceholder: 'Expliquez pourquoi ces assets sont rejetés...',
        noAssets: 'Aucun asset à modérer',
        noAssetsDescription: 'Tous les assets de ce workspace ont été examinés.',
        name: 'Nom',
        type: 'Type',
        date: 'Date',
        status: 'Statut',
        actions: 'Actions',
        view: 'Voir',
        searchPlaceholder: 'Rechercher des assets...',
        approveSuccessSingle: 'Asset approuvé — désormais visible dans cet espace',
        approveSuccessMultiple: '{count} assets approuvés — désormais visibles dans cet espace',
        approveError: "Échec de l'approbation des assets",
        rejectSuccessSingle: 'Asset rejeté',
        rejectSuccessMultiple: '{count} assets rejetés',
        rejectError: 'Échec du rejet des assets',
        resetSelected: 'Remettre en attente la sélection',
        resetSuccessSingle: 'Asset remis en attente',
        resetSuccessMultiple: '{count} assets remis en attente',
        resetError: 'Échec de la remise en attente des assets',
        rejectReasonOptional: 'Raison du rejet (facultative)',
        poolHint: 'Approuver un asset du fonds commun le valide : il devient en lecture seule pour tous, sauf pour les modérateurs du fonds commun. Le remettre en attente le rend de nouveau modifiable.',
        loadError: 'Impossible de charger la file de modération.',
        loadMore: 'Afficher plus',
        noRejected: 'Aucun asset rejeté',
        noRejectedDescription: 'Rien n\'a été refusé dans cet espace.',
        noApproved: 'Aucun asset approuvé',
        noApprovedDescription: 'Rien n\'a encore été approuvé dans cet espace.',
        revisions: 'Révisions',
        approveRevision: 'Valider les modifications',
        saveAmendmentsFirst: 'Enregistrez d’abord vos retouches : la validation applique le brouillon tel qu’il est enregistré.',
        changedFields: 'Modifié :',
        draftFields: {
            excerpt: 'Résumé',
            rights: 'Droits',
            language: 'Langue',
            metadata: 'Métadonnées ({count}) | Métadonnées ({count})',
        },
        rejectRevision: 'Refuser les modifications',
        rejectRevisionTitle: 'Refuser les modifications',
        rejectRevisionLead: 'La vidéo reste validée et visible. Les modifications sont renvoyées à {name} avec votre message, pour correction et nouvelle soumission.',
        rejectRevisionDone: 'Modifications refusées : elles ont été renvoyées avec votre message.',
        approvedIn: 'Validé dans « {workspace} »',
        approvedUnstamped: 'Approuvé',
        withdrawApproval: 'Retirer la validation',
        withdrawTitle: 'Retirer la validation ?',
        withdrawLead: 'L’asset repasse en attente : les membres de « {workspace} » ne le voient plus jusqu’à une nouvelle décision.',
        withdrawUnlocks: 'Il redevient modifiable par ceux que la validation verrouillait.',
        withdrawDone: 'Validation retirée : l’asset est de nouveau en attente',
        banner: {
            pending: 'En attente de validation',
            rejected: 'Rejeté',
            revision: 'Modifications à valider',
            approved: 'Validé',
        },
        noRevisions: 'Aucune révision en cours',
        noRevisionsDescription: 'Aucun asset validé n’est en cours de modification.',
        lastDecision: 'Dernière décision',
        neverDecided: 'Aucune décision',
        quick: {
            more: 'Autres actions',
            rejectWithReason: 'Rejeter avec une raison',
            approveRevision: 'Valider',
            rejectRevision: 'Refuser',
            revisionApproved: 'Modifications validées',
        },
        reasonLine: 'Raison : {reason}',
        formerMember: 'un ancien membre',
        uploadedBy: 'Envoyé par {name}',
        uploadedByFrom: 'Envoyé par {name} depuis {workspace}',
        depositedVia: 'Déposé par {name} via {channel}',
        decisionLine: {
            pending: 'Remis en attente le {date} par {name}',
            approved: 'Approuvé le {date} par {name}',
            rejected: 'Rejeté le {date} par {name}',
            exempted: 'Exempté le {date}',
        },
        submittedLine: 'Modifications soumises le {date} par {name}',
        outcomeSummary: '{decided} décidé(s), {unchanged} déjà dans cet état, {notPlaced} absent(s) de cet espace',
        notModerated: 'Cet espace ne modère pas ses assets : activez la modération dans ses paramètres.',
        reasonRequired: 'Votre organisation exige une raison pour tout rejet.',
        moderationCard: {
            pendingLabel: 'En attente de validation — {name}',
            approvedLabel: 'Approuvé — {name}',
            rejectedLabel: 'Rejeté — {name}',
            pendingDescription: 'Cet asset est en attente de validation avant d\'être visible.',
            approvedDescription: 'Cet asset a été approuvé et est visible.',
            rejectedDescription: 'Cet asset a été rejeté et n\'est pas visible.',
            viewReason: 'Voir la raison',
            rejectionReasonTitle: 'Raison du rejet',
            approveSuccess: 'Asset approuvé',
            rejectSuccess: 'Asset rejeté',
            resetPendingSuccess: 'Asset remis en attente',
            approveError: "Échec de l'approbation de l'asset",
            rejectError: "Échec du rejet de l'asset",
            resetPendingError: "Échec de la remise en attente de l'asset",
        },
    },
    validation: {
        lockedLabel: 'Validé — lecture seule',
        validated: 'Validé',
        validatedBy: 'Validé par {name}',
        validatedOn: 'Validé le {date}',
        validatedByOn: 'Validé par {name} le {date}',
        banner: {
            locked: { title: 'Validé dans le fonds commun', subtitle: 'lecture seule' },
            editing: { title: 'Brouillon en cours', subtitle: 'vos modifications restent dans votre brouillon : l’asset ne change pas tant qu’un modérateur ne les a pas validées' },
            othersDraft: { title: 'Modifications en cours', subtitle: 'seul son auteur peut modifier ce brouillon, le soumettre ou l’abandonner' },
            returned: { title: 'Modifications refusées', subtitle: 'corrigez-les puis soumettez de nouveau' },
            submitted: { title: 'Modifications soumises', status: 'En attente de validation' },
        },
        rejection: {
            titleByOn: 'Vos modifications ont été refusées par {name} le {date}',
            titleOn: 'Vos modifications ont été refusées le {date}',
            hint: 'L’asset n’a pas changé. Corrigez votre brouillon puis soumettez-le de nouveau, ou abandonnez-le.',
            dismiss: 'Fermer le message',
        },
        unsaved: {
            title: 'Modifications non enregistrées',
            text: 'Vous avez des modifications que vous n’avez pas enregistrées. Si vous quittez cet onglet, elles seront perdues.',
            stay: 'Rester et enregistrer',
            leave: 'Quitter sans enregistrer',
            beforeSubmit: 'Enregistrez d’abord vos modifications dans : {tabs}. Sinon, elles ne feront pas partie de ce que vous soumettez.',
        },
        changed: 'Modifié',
        before: 'Avant :',
        emptyValue: '(vide)',
        revert: 'Rétablir',
        submittedLabel: 'En attente de validation',
        revisionSubmittedByOn: 'Soumis par {name} le {date}',
        revisionSubmittedOn: 'Soumis le {date}',
        submitAction: 'Soumettre à validation',
        resubmitAction: 'Soumettre de nouveau',
        submitTitle: 'Soumettre vos modifications',
        submitLead: 'Décrivez ce que vous avez changé : c’est ce que les modérateurs du fonds commun liront pour valider.',
        submitReason: 'Qu’avez-vous modifié ?',
        submitReasonPlaceholder: 'Par exemple : titre corrigé, nouvelle vignette, sous-titres ajoutés',
        submitNote: 'Votre brouillon ne pourra plus être modifié ni abandonné jusqu’à la décision des modérateurs.',
        submitConfirm: 'Soumettre',
        submitDone: 'Modifications soumises aux modérateurs du fonds commun.',
        submitError: 'Impossible de soumettre les modifications.',
        abandonAction: 'Abandonner',
        abandonTitle: 'Abandonner le brouillon ?',
        abandonText: 'Vos modifications seront perdues. L’asset reste tel qu’il a été validé.',
        abandonConfirm: 'Abandonner le brouillon',
        abandonDone: 'Brouillon abandonné.',
        abandonError: 'Impossible d’abandonner le brouillon.',
        draftSaved: 'Brouillon enregistré.',
        draftSaveError: 'Impossible d’enregistrer le brouillon.',
        revisionLead: 'Cet asset a été validé par les modérateurs du fonds commun. Voici ce qui se passe si vous le modifiez :',
        revisionSteps: {
            edit: { title: 'Vous rédigez un brouillon', text: 'Titre, description, tags et métadonnées se modifient comme d’habitude, mais dans votre brouillon. Rien n’est envoyé tant que vous n’avez pas soumis.' },
            visible: { title: 'L’asset ne change pas', text: 'Il reste visible dans le fonds commun tel qu’il a été validé, pour tout le monde.' },
            review: { title: 'Un modérateur valide', text: 'Quand vous soumettez, un modérateur compare et valide : vos modifications sont alors appliquées à l’asset.' },
        },
        revisionLabel: 'En cours de modification',
        revisionByOn: 'Démarrée par {name} le {date}',
        revisionOn: 'Démarrée le {date}',
        revisionReasonLine: '« {reason} »',
        revisionHint: 'Des modifications de cet asset sont proposées : il reste visible tel qu’il a été validé jusqu’à leur validation.',
        revisionOnisepNote: 'ONISEP garde la version déjà reçue et ne recevra vos modifications qu’une fois validées.',
        revisionLiftsHint: 'Son propriétaire propose des modifications : une fois soumises, validez-les depuis l’onglet Révisions de la modération ou depuis cette page.',
        reviseAction: 'Modifier',
        revisionTitle: 'Modifier un asset validé',
        revisionConfirm: 'Ouvrir un brouillon',
        revisionOpened: 'Brouillon ouvert : modifiez la fiche, puis soumettez-la quand vous avez fini.',
        revisionError: 'Impossible d’ouvrir la modification de cet asset.',
        bindsHint: 'Validé dans le fonds commun, cet asset est en lecture seule. Seul un modérateur du fonds commun peut le modifier, ou le remettre en attente pour le rendre modifiable.',
        liftsHint: 'Vous modérez le fonds commun : vous gardez tous les droits. Le remettre en attente le rend modifiable par les autres.',
        selectionLocked: 'La sélection contient un asset validé dans le fonds commun : seul un modérateur du fonds commun peut le déplacer ou le supprimer.',
        deletionLocked: 'Suppression impossible : la sélection contient, dossiers compris, {count} asset validé dans le fonds commun. Seul un modérateur du fonds commun peut le supprimer. | Suppression impossible : la sélection contient, dossiers compris, {count} assets validés dans le fonds commun. Seul un modérateur du fonds commun peut les supprimer.',
        unlockedLabel: 'Validation',
        lockedDescription: "Cet asset a été validé et verrouillé. La modification est désactivée pour tout le monde sauf les administrateurs.",
        lockedBy: 'Validé par {name}. La modification est verrouillée pour tous les autres.',
        lockedByOn: 'Validé par {name} le {date}. La modification est verrouillée pour tous les autres.',
        unlockedDescription: "Validez cet asset pour le verrouiller en lecture seule pour tous les autres membres, y compris la personne qui l'a envoyé.",
        validateAction: 'Valider et verrouiller',
        unlockAction: 'Déverrouiller',
        validateSuccess: 'Asset validé et verrouillé',
        validateError: "Échec de la validation de l'asset",
        unlockSuccess: 'Asset déverrouillé',
        unlockError: "Échec du déverrouillage de l'asset",
    },
    storage: {
        title: 'Détails du stockage',
        loadError: 'Échec du chargement des statistiques de stockage',
        videoSection: 'Vidéos',
        videoDescription: 'Stockage des contenus vidéo',
        audioSection: 'Audio',
        audioDescription: 'Stockage des contenus audio',
        filesSection: 'Autres fichiers',
        filesDescription: 'Images, documents et autres fichiers',
        totalDuration: 'Durée totale',
        totalSize: 'Taille totale',
        fileCount: 'Fichiers',
        files: 'fichiers',
        noOtherFiles: 'Aucun autre fichier stocké',
        totalStorage: 'Stockage total utilisé',
        costs: {
            title: 'Par catégorie',
            subtitle: 'Ce que chaque partie du stockage coûte chaque mois, aux tarifs actuels.',
            volumesOnly: 'Les volumes, sans les montants.',
            total: 'Total mensuel estimé',
            perMonth: '{amount}/mois',
            rates: '{hour} par heure de vidéo et {gigabyte} par Go, chaque mois',
            // Videos billed by the bytes of their sources (`docs/plans/org-pricing.md` OP6).
            ratesBytes: '{gigabyte} par Go chaque mois, vidéos comprises au Go de leurs sources',
            categories: {
                video: { label: 'Vidéos' },
                old_versions: { label: 'Anciennes versions' },
                sources: { label: 'Sources des vidéos, toutes versions comprises' },
                renditions: { label: 'Versions encodées' },
                audio: { label: 'Audio' },
                files: { label: 'Autres fichiers' },
                trash: { label: 'Corbeille' },
            },
        },
        types: {
            images: 'Images',
            documents: 'Documents',
            files: 'Autres fichiers',
            archives: 'Archives',
            subtitles: 'Sous-titres',
            collections: 'Collections',
            thirdParty: 'Vidéos externes',
            other: 'Autres',
        },
    },
    embed: {
        title: 'Intégrer',
        publicationError: 'Impossible de préparer le code d\'intégration de ce média.',
        instruction: 'Copiez ce code et collez-le sur votre site web',
        integrationGroup: 'Intégration',
        dimensionsGroup: 'Dimensions',
        optionsGroup: 'Options & lecture',
        preset: 'Préréglage',
        presetHint: 'Le préréglage choisi est écrit dans le code ; sans choix, celui par défaut s\'applique. Rien n\'est enregistré.',
        dimensions: 'Dimensions',
        responsive: 'Largeur responsive',
        responsiveRecommended: 'Largeur responsive (recommandé)',
        responsiveDesc: 'Le lecteur s\'adaptera automatiquement à la largeur de son conteneur',
        aspectRatio: 'Format',
        aspectRatioCustom: 'Personnalisé',
        fluidWidthHint: 'Largeur : 100 % du conteneur',
        width: 'Largeur',
        height: 'Hauteur',
        options: 'Options',
        integration: 'Intégration',
        autoResize: 'Auto-resize',
        autoResizeDesc: 'Ajuste automatiquement la hauteur de l\'iframe au contenu du lecteur (nécessite un petit script en plus de l\'iframe)',
        embedMethod: 'Méthode d\'intégration',
        embedMethodScript: 'Script',
        embedMethodScriptDesc: 'Intégration moderne : auto-resize, API JS, patchable côté serveur.',
        embedMethodIframe: 'Iframe',
        embedMethodIframeDesc: 'Ancien snippet iframe. À utiliser sur les sites qui bloquent les scripts tiers.',
        display: 'Affichage',
        displayInline: 'Dans la page',
        displayInlineDesc: 'Le lecteur est intégré directement dans la page.',
        displayPopover: 'Bouton',
        displayPopoverDesc: 'Un déclencheur ouvre la vidéo en plein écran au clic. La vidéo ne se charge qu’au clic.',
        trigger: 'Déclencheur',
        triggerButton: 'Bouton',
        triggerThumbnail: 'Vignette',
        triggerLabel: 'Libellé du bouton',
        triggerLabelPlaceholder: 'Voir la vidéo',
        triggerPreview: 'Aperçu',
        triggerPreviewHint: 'Cliquez pour prévisualiser la popup.',
        triggerThumbnailUsesPoster: 'Utilise la miniature du média avec un bouton play au centre.',
        triggerThumbnailNoPoster: 'Aucune miniature disponible pour ce média — le déclencheur affichera un bouton play sur fond neutre.',
        copyCode: 'Copier le code',
        copied: 'Code copié !',
        videoLinkBadge: 'Lien',
        openInTab: 'Voir le rendu dans un onglet',
        advancedOptions: 'Options avancées',
        advancedOptionsDesc: 'Tous les paramètres de personnalisation sur l\'onglet Développeur',
        adaptToPlatform: 'Adapter à ma plateforme',
        destinationTrace: 'Pour {destination} · changer',
        presetLabel: 'Préréglage',
        presetHint: 'Vos couleurs, votre logo et vos options enregistrés, à réutiliser d\'un média à l\'autre.',
        assistant: {
            pickerLabel: 'Pour',
            menuOther: 'Autres destinations',
            menuChange: '{destination} — changer de destination',
            menuGroups: {
                html: 'Coller du HTML',
                link: 'Coller un lien',
            },
            deliverySnippet: 'Le code à coller',
            deliveryUrl: 'L\'URL à coller',
            deliveryEmail: 'Le bloc à coller dans votre email',
            advanced: 'Réglages avancés',
            advancedHint: 'Méthode, dimensions, options de lecture, préréglages',
            destinations: {
                web: {
                    label: 'Site web',
                    note: 'Lecteur responsive au format 16:9 : il épouse la largeur de votre page et reste lisible sur mobile.',
                    steps: 'Collez ce code dans le HTML de votre page, à l\'endroit exact où le lecteur doit apparaître. Si votre éditeur a un mode HTML, passez dedans avant de coller.',
                },
                wordpress: {
                    label: 'WordPress',
                    note: 'Le code Script fonctionne dans WordPress, à condition de le coller dans un bloc HTML et non dans l\'éditeur visuel.',
                    steps: 'Éditeur Gutenberg : ajoutez un bloc « HTML personnalisé » et collez le code dedans. Éditeur classique : passez sur l\'onglet « Texte », puis collez.',
                    caveat: 'Il n\'existe pas encore d\'extension ni de shortcode Videas pour WordPress : le bloc HTML est la façon d\'intégrer aujourd\'hui.',
                },
                newsletter: {
                    label: 'Newsletter',
                    note: 'Les logiciels de messagerie bloquent les lecteurs vidéo. Nous préparons donc une vignette cliquable qui ouvre le média dans le navigateur : cela fonctionne dans toutes les boîtes mail.',
                    steps: 'Collez ce bloc dans l\'éditeur HTML de votre newsletter — le bloc « Code » chez Mailchimp, Brevo ou Mailjet.',
                },
                wix: {
                    label: 'Wix',
                    note: 'Wix bloque souvent les scripts externes : nous préparons donc une iframe, qui ne dépend d\'aucun JavaScript.',
                    steps: 'Ajoutez un élément « HTML personnalisé » à votre page, puis collez le code dedans.',
                    caveat: 'L\'ouverture par bouton n\'est pas disponible ici : elle a besoin de notre script, que Wix bloque. Le lecteur s\'affiche donc directement dans la page.',
                },
                squarespace: {
                    label: 'Squarespace',
                    note: 'Lecteur responsive au format 16:9 : il épouse la largeur de votre page et reste lisible sur mobile.',
                    steps: 'Ajoutez un bloc « Code » à votre page, puis collez le code dedans.',
                },
                webflow: {
                    label: 'Webflow',
                    note: 'Lecteur responsive au format 16:9 : il épouse la largeur de votre page et reste lisible sur mobile.',
                    steps: 'Glissez un élément « Embed » dans votre page, puis collez le code dedans.',
                },
                wiki: {
                    label: 'Wiki interne',
                    note: 'Confluence et la plupart des intranets filtrent le JavaScript : nous préparons donc une iframe, qui n\'en a pas besoin.',
                    steps: 'Collez ce code dans un bloc HTML de votre page.',
                    caveat: 'L\'ouverture par bouton n\'est pas disponible ici : elle a besoin de notre script, que ces outils filtrent. Le lecteur s\'affiche donc directement dans la page.',
                },
                notion: {
                    label: 'Notion',
                    note: 'Notion n\'accepte pas les balises script : il lui faut l\'URL seule, qu\'il transforme lui-même en lecteur.',
                    steps: 'Dans votre page, tapez /embed, collez cette URL, puis validez.',
                    caveat: 'Sur un wiki d\'entreprise qui refuse l\'URL, choisissez plutôt « Wiki interne » : vous obtiendrez une iframe.',
                },
            },
            recap: {
                methodScript: 'Code Script',
                methodIframe: 'Code iframe',
                displayPopover: 'Bouton qui ouvre le lecteur',
                responsive: 'Largeur responsive',
                fixedWidth: 'Largeur {width} px',
                ratio: 'Format {ratio}',
                clickableThumbnail: 'Vignette cliquable',
                textLink: 'Lien texte',
                opensInBrowser: 'Ouvre le média dans le navigateur',
                bareUrl: 'URL seule',
                hostBuildsPlayer: 'Notion fabrique le lecteur',
            },
            email: {
                ctaVideo: 'Regarder la vidéo',
                ctaMedia: 'Voir le contenu',
                noThumbnail: 'Ce média n\'a pas de miniature : le bloc livré se limite à un lien texte. Ajoutez une miniature au média pour obtenir une vignette cliquable.',
                domainRestriction: 'Si vous avez restreint les domaines autorisés à afficher ce lecteur, ce lien ne s\'ouvrira pas depuis une boîte mail : un clic dans un email n\'a pas de domaine d\'origine.',
            },
        },
    },
    playerSettings: {
        title: 'Réglages du lecteur',
        presetName: 'Mon lecteur',
        preview: 'Aperçu',
        appearance: 'Apparence',
        theme: 'Thème',
        accent: 'Couleur d\'accent',
        accentCustom: 'Couleur personnalisée',
        accentReset: 'Réinitialiser',
        colorfulHint: 'Le thème « Couleur » floute la pochette derrière les contrôles. Il n\'existe que pour l\'audio.',
        logo: 'Logo',
        logoHelper: 'Il s\'affiche en filigrane sur vos lecteurs, et sert pour tous vos médias.',
        logoInherited: 'Ce logo vient des réglages de l\'organisation. En choisir un ici ne vaudra que pour cet espace de travail.',
        showLogo: 'Afficher le logo',
        showLogoHint: 'En filigrane sur le lecteur',
        showLogoEmpty: 'Choisissez d\'abord un logo ci-dessus',
        logoOnPlay: 'Le filigrane apparaît dès que la lecture démarre — jamais sur l\'image d\'accroche.',
        logoPosition: 'Position',
        positions: {
            top_left: 'Haut gauche',
            top_right: 'Haut droite',
            bottom_left: 'Bas gauche',
            bottom_right: 'Bas droite',
            control_bar: 'Barre de contrôle',
        },
        logoPositionNote: {
            audio: 'Sur un lecteur audio, le logo se place dans l\'en-tête : il n\'y a pas de position à choisir.',
            pinned: 'Pour ce type de média, le logo est fixé en bas à droite.',
        },
        behaviour: 'Comportement',
        toggles: {
            ecoModeDefault: {
                label: 'Mode éco par défaut',
                hint: 'Démarre en qualité réduite',
            },
        },
        locked: 'La personnalisation des lecteurs est verrouillée pour cet espace de travail. Vous pouvez voir les réglages, pas les modifier.',
        advanced: 'Réglages avancés',
        scope: 'Ces réglages deviennent votre lecteur par défaut pour ce type de média : ils s\'appliquent aussi aux intégrations déjà en ligne qui n\'ont pas de réglage propre. Le logo, lui, est un réglage d\'espace de travail — il vaut pour tous les types de médias à la fois.',
        snippetOptions: 'La lecture automatique, la boucle, le son et les autres options de lecture s\'inscrivent dans le code d\'intégration lui-même, pas dans vos réglages. {help}',
        snippetOptionsLink: 'Voir tous les paramètres du lecteur',
        saveError: 'Les réglages n\'ont pas pu être enregistrés. Réessayez dans un instant.',
        subtitle: {
            video: 'Couleur, logo et comportement de tous vos lecteurs vidéo.',
            audio: 'Couleur, logo et comportement de tous vos lecteurs audio.',
            image: 'Thème, logo et comportement de toutes vos images intégrées.',
            document: 'Logo et comportement de tous vos documents intégrés.',
            collection: 'Couleur, logo et comportement de toutes vos collections intégrées.',
        },
        previewNote: {
            video: 'C\'est le lecteur réel, pas une image : ce que vous voyez ici est ce que verront vos visiteurs.',
            audio: 'Le thème « Couleur » reprend la pochette en fond. C\'est le thème par défaut de l\'audio.',
            image: 'Une image intégrée n\'a pas de couleur d\'accent : seuls le thème et le logo la concernent.',
            document: 'Un document intégré n\'a ni thème ni couleur d\'accent : seul le logo le concerne.',
        },
        accentEmpty: {
            video: 'Sans couleur choisie, le lecteur reprend celle de la plateforme.',
            audio: 'Sans couleur choisie, l\'accent est repris de la pochette du média.',
        },
    },
    developer: {
        title: 'Développeur',
        subtitle: 'Intégrez et accédez à cet asset de manière programmatique',
        error: {
            title: 'Erreur de chargement',
            description: 'Impossible de charger les informations d\'intégration',
            retry: 'Réessayer',
        },
        notEmbeddable: {
            title: 'Intégration non disponible',
            description: 'Ce type d\'asset ne prend pas en charge l\'intégration. Seuls les vidéos, audios, images, documents et collections peuvent être intégrés.',
        },
        unavailable: {
            title: 'Intégration non disponible',
            description: 'Ce média n\'a pas encore de code d\'intégration, et votre rôle dans cet espace ne permet pas d\'en créer un.',
        },
        advanced: {
            title: 'Avancé',
            description: 'Ce qui se règle une fois pour toutes.',
        },
        sourceDownload: {
            label: 'Autoriser le téléchargement de la source',
            hint: 'Affiche un bouton de téléchargement dans le lecteur. S\'applique à tous les codes déjà intégrés, sans les modifier.',
            hintCollection: 'Dans une playlist, le spectateur peut ainsi télécharger chaque vidéo, une à une.',
            readOnly: 'Seule une personne qui peut partager ce contenu peut changer ce réglage.',
            saved: 'Téléchargement de la source enregistré',
            saveError: 'Échec de l\'enregistrement du téléchargement de la source',
        },
        advertising: {
            label: 'Afficher la publicité',
            hint: 'Activée par défaut dès que la publicité est configurée. S\'applique à tous les codes déjà intégrés, sans les modifier.',
            readOnly: 'Seule une personne qui peut modifier ce contenu peut changer ce réglage.',
            saved: 'Publicité enregistrée',
            saveError: 'Échec de l\'enregistrement de la publicité',
        },
        access: {
            title: 'Accès au lecteur',
            description: 'Qui peut afficher ce lecteur, et où.',
            levels: {
                public: 'Public',
                publicDescription: 'S\'affiche sur n\'importe quel site.',
                domainRestricted: 'Domaines autorisés',
                domainRestrictedDescription: 'S\'affiche seulement sur les sites que vous listez.',
                tokenRequired: 'Jeton d\'accès',
                tokenRequiredDescription: 'S\'ouvre seulement avec un jeton ajouté au code.',
            },
            domains: 'Domaines',
            domainsPlaceholder: 'exemple.com',
            domainsHint: 'Entrée ou virgule pour ajouter un domaine ; *.exemple.com couvre tous ses sous-domaines.',
            workspaceNote: 'La liste de domaines de l\'espace s\'applique en plus de ce réglage.',
            codeHint: 'Ce lecteur ne s\'affichera pas partout.',
            edit: 'Modifier l\'accès',
            cancel: 'Annuler',
            save: 'Enregistrer',
            saved: 'Accès enregistré',
            saveError: 'Échec de l\'enregistrement de l\'accès',
            howto: {
                title: 'Comment ça marche ?',
                step1: 'Créez un jeton par site ou partenaire autorisé.',
                step2: 'Copiez le code fourni à la création : il contient déjà le jeton, et le destinataire le colle tel quel.',
                step3: 'Révoquez un jeton pour couper l\'accès de ce site seulement, sans toucher aux autres.',
                caveat: 'Le jeton reste lisible dans le code source du site qui l\'intègre : il identifie un partenaire, il n\'empêche pas la copie. Pour réserver le lecteur à vos sites, choisissez les domaines autorisés.',
            },
            summary: {
                public: 'Public',
                domains: 'Aucun domaine | 1 domaine | {n} domaines',
                tokens: 'Jeton requis',
                tokensActive: 'Jeton requis · aucun actif | Jeton requis · 1 actif | Jeton requis · {n} actifs',
            },
            tokens: {
                title: 'Jetons d\'accès',
                description: 'Un jeton par site ou partenaire, révocable à tout moment.',
                empty: 'Aucun jeton pour ce lecteur.',
                labelPlaceholder: 'Nom du destinataire, par exemple Site partenaire',
                unnamed: 'Sans nom',
                createdOn: 'Créé le {date}',
                create: 'Créer un jeton',
                revoke: 'Révoquer',
                revoked: 'Révoqué',
                active: 'Actif',
                secretTitle: 'Copiez ce jeton maintenant',
                secretDescription: 'Il ne sera plus affiché. Voici le code d\'intégration qui le contient déjà, prêt à coller sur le site du destinataire.',
                copy: 'Copier',
                copyCode: 'Copier le code',
                codeCopied: 'Code copié',
                secretLabel: 'Jeton seul',
                copied: 'Jeton copié',
                dismiss: 'Masquer',
                createError: 'Échec de la création du jeton',
                revokeError: 'Échec de la révocation du jeton',
            },
        },
        settings: {
            saved: 'Paramètres enregistrés',
            saveError: 'Erreur lors de l\'enregistrement',
        },
        embedCode: {
            title: 'Code d\'intégration',
            copyCode: 'Copier le code',
            copyCodeAgain: 'Recopier le code modifié',
            copied: 'Copié !',
            copyError: 'Échec de la copie',
            showPreview: 'Aperçu',
            hidePreview: 'Masquer l\'aperçu',
            codeUpdated: 'Code d\'intégration mis à jour — vos modifications sont reflétées dans le code ci-dessus.',
            scrollToCode: 'Copier le code',
        },
        customize: {
            title: 'Paramètres du lecteur',
            description: 'Configurez l\'apparence et le comportement du lecteur.',
            dimensions: 'Dimensions',
            responsive: 'Largeur responsive',
            responsiveDesc: 'Le lecteur remplira la largeur de son conteneur',
            aspectRatio: 'Format',
            aspectRatioCustom: 'Personnalisé',
            aspectRatioCustomLabel: 'Format personnalisé (L : H)',
            fluidWidthHint: 'Largeur : 100 % du conteneur',
            integrationGroup: 'Intégration',
            dimensionsGroup: 'Dimensions',
            playbackGroup: 'Lecture & comportement',
            embedMethod: 'Méthode d\'intégration',
            embedMethodDesc: 'Le mode script est recommandé et fonctionne partout. Utilisez l\'iframe en secours sur les sites à CSP strict.',
            embedMethodScript: 'Script',
            embedMethodScriptDesc: 'Intégration moderne : auto-resize, API JS, patchable côté serveur.',
            embedMethodIframe: 'Iframe',
            embedMethodIframeDesc: 'Ancien snippet iframe. À utiliser sur les sites qui bloquent les scripts tiers.',
            display: 'Affichage',
            displayDesc: 'Intégré insère le lecteur dans la page ; popover l\'ouvre en plein écran au clic (la vidéo ne se charge qu\'au clic).',
            displayInline: 'Intégré',
            displayPopover: 'Popover',
            trigger: 'Déclencheur',
            triggerDesc: 'Ce sur quoi le visiteur clique pour ouvrir le popover.',
            triggerButton: 'Bouton',
            triggerThumbnail: 'Vignette',
            triggerLabel: 'Libellé du bouton',
            triggerLabelDesc: 'Laissez vide pour traduire automatiquement selon la langue du visiteur.',
            triggerLabelPlaceholder: 'Voir la vidéo',
            triggerPreview: 'Aperçu',
            triggerPreviewHint: 'Cliquez pour prévisualiser la popup.',
            triggerThumbnailLabel: 'Vignette',
            triggerThumbnailUsesPoster: 'Utilise la miniature du média avec un bouton play au centre.',
            triggerThumbnailNoPoster: 'Aucune miniature disponible — le déclencheur affiche un bouton play sur fond neutre.',
            width: 'Largeur',
            height: 'Hauteur',
            autoResize: 'Auto-resize',
            autoResizeDesc: 'Ajuste automatiquement la hauteur de l\'iframe au contenu du lecteur (nécessite un petit script en plus de l\'iframe)',
            options: 'Options',
        },
        options: {
            startAt: 'Démarrer à',
            startAtDesc: 'Démarrer la lecture à un moment précis (ex. 1:30 ou 90)',
            autoplay: 'Lecture automatique',
            autoplayDesc: 'Démarrer la lecture automatiquement au chargement de la page',
            autoplayMutedWarning: 'Les navigateurs bloquent la lecture automatique avec le son activé. Activez « Muet » pour que la lecture automatique fonctionne.',
            loop: 'Boucle',
            loopDesc: 'Reprendre la lecture lorsqu\'elle atteint la fin',
            muted: 'Muet',
            mutedDesc: 'Démarrer avec le son coupé (requis pour la lecture automatique dans la plupart des navigateurs)',
            controls: 'Contrôles',
            controlsDesc: 'Afficher les contrôles de lecture au spectateur',
            pinControls: 'Contrôles toujours visibles',
            pinControlsDesc: 'Garder la barre de contrôles affichée en permanence (désactive le masquage automatique)',
            seeking: 'Navigation dans la vidéo',
            seekingDesc: 'Laisser le spectateur avancer ou reculer avec la barre de progression, le clavier ou les chapitres. Désactivée, la lecture se suit du début à la fin ; la reprise où il s\'était arrêté reste proposée',
            showChapters: 'Afficher les chapitres',
            showChaptersDesc: 'Afficher les marqueurs de chapitres sur la barre de progression',
            enablePip: 'Picture-in-picture',
            enablePipDesc: 'Permettre au spectateur d\'utiliser le mode picture-in-picture',
            enableFullscreen: 'Plein écran',
            enableFullscreenDesc: 'Permettre au spectateur de passer en plein écran',
            shuffle: 'Lecture aléatoire',
            shuffleDesc: 'Lire les pistes dans un ordre aléatoire',
            showWaveform: 'Afficher la forme d\'onde',
            showWaveformDesc: 'Afficher la visualisation de la forme d\'onde audio',
            showPlaylist: 'Afficher la playlist',
            showPlaylistDesc: 'Afficher le panneau de playlist pour les intégrations multi-pistes',
            enableZoom: 'Activer le zoom',
            enableZoomDesc: 'Permettre au spectateur de zoomer dans l\'image',
            allowDownload: 'Autoriser le téléchargement',
            allowDownloadDesc: 'Permettre aux spectateurs de télécharger le fichier original',
            showCaption: 'Afficher la légende',
            showCaptionDesc: 'Afficher le nom de l\'asset comme légende sous le lecteur',
            startPage: 'Page de départ',
            startPageDesc: 'Ouvrir le document à un numéro de page spécifique',
            showThumbnails: 'Afficher les miniatures',
            showThumbnailsDesc: 'Afficher une barre latérale ou bande de miniatures',
            showOutline: 'Afficher le sommaire',
            showOutlineDesc: 'Afficher la table des matières du document',
            autoplayNext: 'Lecture suivante auto',
            autoplayNextDesc: 'Lire automatiquement l\'élément suivant de la collection',
            showAds: 'Afficher la publicité',
            showAdsDesc: 'Diffuser la publicité configurée sur cet embed',
            displayMode: 'Mode d\'affichage',
            displayModeDesc: 'Comment la playlist de la collection est affichée à côté du lecteur',
            displayModeDrawer: 'Défaut',
            displayModeDrawerDesc: 'La playlist s\'ouvre en superposition',
            displayModeBottomBar: 'Barre inférieure',
            displayModeBottomBarDesc: 'Bande de miniatures sous le lecteur',
            displayModeSidebar: 'Barre latérale',
            displayModeSidebarDesc: 'Bande de miniatures verticale sur le côté',
            posterFit: 'Ajustement de la vignette',
            posterFitDesc: 'Comment la vignette remplit le lecteur avant la lecture',
            posterFitContain: 'Ajuster',
            posterFitCover: 'Remplir',
            audioTheme: 'Thème du lecteur',
            audioThemeDesc: 'Choisir l\'apparence visuelle du lecteur audio',
            themeLight: 'Clair',
            themeDark: 'Sombre',
            themeColorful: 'Coloré',
            iconColor: "Couleur d'accent",
            iconColorDesc: 'Couleur personnalisée pour le lecteur (boutons, barre de progression, waveform...)',
            iconColorReset: 'Réinitialiser',
            showHomepageInfo: 'Afficher les infos',
            showHomepageInfoDesc: 'Afficher le titre et la durée sur la vignette du lecteur',
            showHomepagePlayButton: 'Afficher le bouton lecture',
            showHomepagePlayButtonDesc: 'Afficher le bouton lecture sur la vignette du lecteur',
            showEcoMode: 'Bouton mode éco',
            showEcoModeDesc: 'Afficher le bouton mode éco dans le lecteur',
            ecoModeDefault: 'Mode éco par défaut',
            ecoModeDefaultDesc: 'Démarrer la lecture en mode éco (qualité de streaming limitée à 720p)',
            showInfoButton: 'Bouton info',
            showInfoButtonDesc: 'Afficher le bouton info dans le lecteur',
            allowSourceDownload: 'Téléchargement de la source',
            allowSourceDownloadDesc: 'Permettre aux spectateurs de télécharger le fichier source original',
            enableSlideshow: 'Activer le diaporama',
            enableSlideshowDesc: 'Permettre le diaporama automatique pour les collections d\'images',
            slideshowDuration: 'Intervalle du diaporama',
            slideshowDurationDesc: 'Temps entre les diapositives en secondes',
            showCaptions: 'Afficher les titres',
            showCaptionsDesc: 'Afficher le titre de l\'image en mode carrousel et sous les vignettes en mode grille',
            enableSearch: 'Activer la recherche',
            enableSearchDesc: 'Permettre au spectateur de rechercher dans le document',
        },
        presets: {
            title: 'Préréglages',
            descriptionNative: 'Choisissez le préréglage appliqué à ce code. Sans choix, le préréglage par défaut de l\'espace de travail s\'applique, sinon celui de l\'organisation.',
            descriptionAsset: 'Ce code publie le média par son identifiant. Choisissez un préréglage pour l\'écrire dans le code ; sans choix, le préréglage par défaut de l\'espace de travail s\'applique, sinon celui de l\'organisation. Le choix n\'est enregistré nulle part : il vit dans le code copié.',
            label: 'Préréglages',
            placeholder: 'Sélectionner un préréglage...',
            save: 'Enregistrer le préréglage',
            saveAs: 'Enregistrer comme préréglage',
            customize: 'Personnaliser',
            actions: 'Actions du préréglage « {name} »',
            chosenBadge: 'Choisi pour ce code',
            readOnlyHint: 'Seuls les administrateurs de l\'organisation peuvent créer ou modifier un préréglage.',
            appliedBanner: 'Le préréglage « {name} » est choisi pour ce code.',
            appliedDefaultBanner: 'Le préréglage par défaut « {name} » s\'applique à ce code.',
            divergingHint: 'Les réglages modifiés ci-dessous s\'y ajoutent dans le code.',
            resetToPreset: 'Rétablir le préréglage',
            clearChoice: 'Retirer ce choix',
            appliedToast: 'Préréglage appliqué à ce code',
            clearedToast: 'Le préréglage par défaut s\'applique de nouveau',
            applyError: 'Impossible d\'appliquer le préréglage',
            saveError: 'Échec de l\'enregistrement du préréglage',
            deleteError: 'Échec de la suppression du préréglage',
            logo: 'Logo du préréglage',
            logoHint: 'Enregistré avec le préréglage : le code ne transporte pas de fichier. Sans logo, le lecteur affiche celui de l\'espace de travail.',
            saveDialog: {
                title: 'Enregistrer comme préréglage',
                name: 'Nom du préréglage',
                namePlaceholder: 'ex. Lecture auto muette',
                save: 'Enregistrer',
                cancel: 'Annuler',
                scope: 'Portée',
                scopeWorkspace: 'Cet espace de travail',
                scopeOrg: 'Tous les espaces (organisation)',
                setAsDefault: 'Définir comme preset par défaut',
                assetModeHint: 'Défini par défaut, il s\'applique aux codes de ce type qui n\'en nomment aucun. Sinon, il est choisi pour ce code.',
                logo: 'Logo',
                logoHint: 'Facultatif. Sans logo, le lecteur affiche celui de l\'espace de travail ou de l\'organisation.',
                deleteTitle: 'Supprimer le préréglage',
                deleteConfirm: 'Êtes-vous sûr de vouloir supprimer le préréglage « {name} » ?',
            },
            rename: 'Renommer',
            renameDialog: {
                title: 'Renommer le préréglage',
                name: 'Nom du préréglage',
                save: 'Renommer',
            },
            update: 'Mettre à jour le préréglage',
            delete: 'Supprimer le préréglage',
            deleteConfirm: 'Supprimer ce préréglage ?',
            hint: 'Paramètres modifiés —',
            hintAction: 'Enregistrer comme préréglage',
            empty: 'Aucun préréglage enregistré',
            saved: 'Préréglage enregistré',
            updated: 'Préréglage mis à jour',
            deleted: 'Préréglage supprimé',
            defaultBadge: 'Par défaut',
            orgBadge: 'Organisation',
            setDefault: 'Définir par défaut',
            removeDefault: 'Retirer le défaut',
            promoteToOrg: 'Partager avec tous les espaces',
            restrictToWorkspace: 'Restreindre à cet espace',
            editingBanner: 'Modification du preset « {name} » — les changements ne sont pas encore enregistrés.',
            editingMessage: 'Modification du preset « {name} »',
            savePreset: 'Enregistrer le preset',
        },
        appearance: {
            title: 'Apparence',
            description: 'Personnalisez l\'apparence visuelle du lecteur.',
            themeGroup: 'Thème & couleur',
            logoGroup: 'Logo',
            playerTheme: 'Thème du lecteur',
            playerThemeDesc: 'Choisissez une apparence claire ou sombre pour les panneaux et overlays du lecteur',
            primaryColor: 'Couleur principale',
            primaryColorDesc: 'Couleur principale personnalisée pour les contrôles et éléments du lecteur',
            primaryColorUrlHint: 'Cette couleur sera incluse dans l\'URL d\'intégration.',
            resetColor: 'Réinitialiser',
            showLogo: 'Afficher le logo',
            showLogoDesc: 'Afficher le logo de l\'espace en superposition sur le lecteur',
            logo: 'Logo',
            logoDesc: 'Afficher un logo personnalisé en superposition sur le lecteur',
            uploadLogo: 'Importer un logo',
            removeLogo: 'Supprimer',
            logoPosition: 'Position du logo',
            logoPositionDesc: 'Où afficher le logo sur le lecteur',
            positionTopLeft: 'Haut gauche',
            positionTopRight: 'Haut droite',
            positionBottomLeft: 'Bas gauche',
            positionBottomRight: 'Bas droite',
            positionControlBar: 'Barre de contrôle',
            logoOpacity: 'Opacité du logo',
            logoOpacityDesc: 'Niveau de transparence du logo en superposition',
            logoClickUrl: 'URL de clic du logo',
            logoClickUrlDesc: 'URL à ouvrir lorsque le spectateur clique sur le logo',
            logoClickUrlPlaceholder: 'https://exemple.com',
            noLogoHint: 'Aucun logo de lecteur n\'est défini : rien ne s\'affichera sur le lecteur. Téléversez-en un dans les {link}.',
            noLogoLink: 'paramètres Lecteurs de médias de l\'espace',
        },
        links: {
            title: 'Liens directs & identifiants',
            description: 'Identifiants pour référencer cet asset via l\'API.',
            assetId: 'ID de l\'asset',
            embedId: 'ID d\'intégration',
            embedUrl: 'URL d\'intégration',
            sourceDownloadUrl: 'Lien permanent du fichier source',
            copy: 'Copier',
            copied: 'Copié !',
        },
        api: {
            title: 'Référence API',
            description: 'Exemples de code pour l\'intégration.',
            getEmbed: 'Obtenir les métadonnées d\'intégration',
            getEmbedDesc: 'Récupérer les éléments de cette intégration et un jeton de lecture valable quatre heures',
            getPlayback: 'Obtenir les infos de lecture',
            getPlaybackDesc: 'Récupérer les sources d\'un élément avec le jeton de lecture de l\'intégration',
            copyCode: 'Copier',
            copied: 'Copié !',
        },
    },
    card: {
        smart: 'Intelligent',
        manual: 'Manuel',
        itemCount: 'Aucun élément | {count} élément | {count} éléments',
        encoding: 'Encodage',
        processing: 'Traitement',
        uploading: 'Envoi en cours',
        awaitingCredit: 'En attente de crédit',
        awaitingCreditHint: 'Le crédit de l\'organisation ne couvre pas le premier mois de stockage de cette vidéo : elle n\'est pas encore encodée. Rechargez votre crédit et l\'encodage reprend de lui-même ; sans recharge, au bout de sept jours d\'attente, elle revient à sa version précédente si elle en a une, et part à la corbeille sinon.',
    },
    assetTypes: {
        video: 'Vidéo',
        image: 'Image',
        audio: 'Audio',
        document: 'Document',
        folder: 'Dossier',
        file: 'Fichier',
        collection: 'Collection',
        archive: 'Archive',
        subtitles: 'Sous-titres',
        thirdParty: 'Vidéo externe',
        other: 'Autre',
        plurals: {
            videos: 'Vidéos',
            images: 'Images',
            audios: 'Audios',
            documents: 'Documents',
        },
    },
}
